export const enTranslations = {
  // Events POC — local demo account switcher
  demo: {
    title: "Demo mode",
    subtitle: "Switch accounts in one click to test the Events POC. Local only.",
    disabled: "Demo mode is not enabled.",
    switching: "Switching account…",
    note: "Fictional accounts created by the API demo script. This page does not exist in production.",
    personas: {
      visitor: {
        name: "Visitor",
        description: "Logged out: what someone scanning the QR code sees.",
      },
      attendee: {
        name: "Alice, attendee",
        description: "Registered to both demo events.",
      },
      orga: {
        name: "Olivia, organizer",
        description: "Creates and manages events.",
      },
      admin: {
        name: "Admin KeepTouch, super-admin",
        description: "Approves organizers and sets their commission.",
      },
    },
    shortcuts: {
      title: "Shortcuts",
      qr: "Event page as seen from the QR code (visitor)",
      ended: "Ended event, full profiles (Alice)",
      dashboard: "Organizer space (Olivia)",
      create: "Create an event (Olivia)",
      admin: "Administration: organizer requests (Admin KeepTouch)",
    },
  },
  errorBoundary: {
    title: 'Oops, something went wrong',
    message: 'An unexpected problem occurred. You can try again.',
  },
  api: {
    'ContactRequest.AlreadyExists': 'You have already sent a contact request to this user',
    'Global.OperationNotAllowedError': 'You are not allowed to perform this operation',
    'Global.ResourceDeletionNotAllowedError': 'You are not allowed to delete this resource',
    'Global.ResourceNotFoundError': 'The resource was not found',
    'IdentityAndAccess.InvalidCredentialsError': 'The email or password is incorrect',
    'IdentityAndAccess.EmailAlreadyTakenError': 'The email is already taken',
    'Networking.CannotCancelNonPendingContactRequestError':
      'You cannot cancel a contact request that is not in the PENDING status',
    'Networking.OnboardingAlreadyCompleteError':
      'You have already completed the onboarding process',
    'Notifications.DeviceAlreadyRegisteredError': 'The device is already registered',
    'Networking.GhostProfileNoEmailError':
      'This profile has no email address. Add an email to send an invitation.',
    NetworkError: 'Network error. Please check your internet connection',
  },
  tabNavigation: {
    home: 'Home',
    contacts: 'Contacts',
    messages: 'Messages',
    notifications: 'Notifications',
    chatbot: 'AI Assistant',
    profile: 'Menu',
  },
  chatbot: {
    title: 'AI Assistant',
    placeholder: 'Ask me anything...',
    thinking: 'Thinking...',
    error: 'An error occurred. Please try again.',
    welcome:
      'Hello! I am your AI assistant. I can help you manage your contacts, notes, categories and hashtags. How can I help you?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    actionConfirmed: 'Action confirmed.',
    actionCancelled: 'Action cancelled.',
    history: 'History',
    historyEmpty: 'No saved conversation.',
    untitled: 'Untitled conversation',
    deleteConversationTitle: 'Delete this conversation?',
    deleteConversationError: 'The conversation could not be deleted. Please try again.',
    suggestionsTitle: 'Here are a few examples:',
    suggestions: {
      notes: 'Search through all my notes',
      conversations: 'Summarise my latest LinkedIn conversation',
      sector: 'Who works in cybersecurity?',
      calendar: 'What are my upcoming appointments?',
      findContact: 'Help me find a contact',
    },
    actions: {
      createNote: 'Create the note "{name}"',
      updateNote: 'Edit the note {name}',
      deleteNote: 'Delete the note {name}',
      createCategory: 'Create the category "{name}"',
      createHashtag: 'Create the hashtag "{name}"',
      createGhostProfile: 'Create the card of {name}',
      updateGhostProfile: 'Edit the card of {name}',
      deleteGhostProfile: 'Delete the card of {name}',
    },
  },
  welcome: {
    title: 'KEEPTOUCH',
    tagline: 'A single contact can change a whole life.',
    connection: 'Connection',
    registration: 'Registration',
    slogan: 'Keep, manage your contacts of tomorrow \n Find and accomplish common projects',
    languageFr: 'Français',
    languageEn: 'English',
    languageEs: 'Español',
  },
  login: {
    title: 'Log in',
    brand: 'KeepTouch',
    tagline: 'Never lose touch with the people who matter',
    email: 'Email address',
    password: 'Password',
    forgotPassword: 'Forgot password?',
    button: 'Login',
    noAccount: "I don't have an account",
    or: 'Or',
    error: {
      noInfo: 'Enter your information',
      wrongCredentials: 'The email or password is incorrect',
      invalidEmail: 'This email address is not valid.',
    },
  },
  register: {
    title: 'Sign up',
    email: 'Email address',
    password: 'Password',
    confirmPassword: 'Re-enter password',
    button: 'Sign up',
    haveAccount: 'I already have an account',
    or: 'Or',
    error: {
      noInfo: 'Enter your information',
      notSamePassword: 'The passwords do not match',
    },
  },
  registerSteps: {
    step2: 'What do you prefer? #',
    step3: 'The best time to contact you?',
    skip: 'Skip',
  },
  registerStep1: {
    title: {
      picture: 'Add your profile picture:',
      gender: 'You are:',
      name: 'Your first name:',
      surname: 'Your last name:',
      birthday: 'Your birthday:',
      athletic: 'Are you sporty:',
      info: 'About you:',
      languages: 'Which languages do you speak:',
      nationality: 'What is your nationality:',
      origin: 'What is your origin:',
      personality: 'What is your personality:',
      residence: 'Where do you live:',
      smoker: 'Do you smoke:',
      conditions: 'I accept the conditions',
      conditionsRead: 'Read:',
    },
    value: {
      women: 'A woman',
      man: 'A man',
      nonBinary: 'A non-binary',
      other: 'Other',
      yes: 'Yes',
      no: 'No',
      calm: 'Calm',
      active: 'Active',
      talkative: 'Talkative',
    },
    next: 'Next',
  },
  registerStepHastags: {
    mainTitle: 'What defines you #',
    title: 'Which hashtags match you',
    placeholder: '#sport',
    next: 'Next',
  },
  registerStep3: {
    mainTitle: 'The best time to contact you?',
    title: 'Select the times when you are most available',
    aperitif: 'Aperitif',
    breakfast: 'Breakfast',
    coffee: 'Coffee',
    dinner: 'Dinner',
    lunch: 'Lunch',
    walk: 'Walk',
    video_call: 'Video call',
    phone_call: 'Phone call',
    videoCall: 'Video call',
    phoneCall: 'Phone call',
    weekend: 'Weekend',
    sport: 'Sport',
    event: 'Event',
    next: 'Next',
  },
  registerStep4: {
    aperitif: 'Aperitif',
    breakfast: 'Breakfast',
    coffee: 'Coffee',
    dinner: 'Dinner',
    lunch: 'Lunch',
    walk: 'Walk',
    videoCall: 'Video call',
    phoneCall: 'Phone call',
    weekend: 'Weekend',
    sport: 'Sport',
    event: 'Event',
    next: 'Next',
  },
  registerFinalStep: {
    congrats: 'Congratulations,\n{name} {surname},\n your account has been created',
    congratsNoName: 'Congratulations,\nyour account has been created',
    next: 'Next',
    geolocationText: 'Enable geolocation for a better user experience',
  },
  forgotPassword: {
    title: 'Reset password',
    email: 'Email address',
    emailConfirm: 'Confirm email address',
    button: 'Send link by email',
    success: 'If an account exists with this email, you will receive a reset link shortly.',
    error: {
      noEmail: 'Please enter your email address.',
      generic: 'Something went wrong. Please try again later.',
    },
  },
  resetPassword: {
    title: 'Set new password',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    button: 'Reset password',
    success: 'Your password has been reset. You can now sign in.',
    error: {
      noToken: 'Invalid or missing reset link. Please request a new one.',
      passwordTooShort: 'Password must be at least 8 characters.',
      passwordMismatch: 'Passwords do not match.',
      generic: 'The reset link may have expired. Please request a new one.',
    },
  },
  contact: {
    title: 'Contacts',
    searchPlaceholder: 'Search for a contact',
    commonContacts: '{nbr} contacts{newline} in common',
    commonProjects: '{nbr} projects{newline} in common',
    addButton: 'Add',
    addTitle: 'Add {name} to your profile ',
    commonTitleModal: 'Friends and projects in common',
    filter: {
      search: 'Search',
      category: {
        location: 'Locations',
        origin: 'Origin',
        role: 'Function',
        degree: 'Degree',
        hashtag: '#',
      },
      location: {
        continent: 'Continent',
        country: 'Search for a country',
        region: 'States / Region',
      },
      nonLocation: {
        origin: 'Search for an origin',
        role: 'Search for a function',
        hashtag: 'Search by #',
      },
    },
    emptyReceivedRequest: 'No requests received for now',
    emptySentRequest: 'No requests sent for now',
    emptyContactPro: 'No professional contacts',
    emptyContactPrivate: 'No private contacts',
  },
  addContact: {
    title: 'Search for a contact',
    commonContacts: '{nbr} contacts{newline} in common',
    commonProjects: '{nbr} projects{newline} in common',
    addButton: 'Add',
    addTitle: 'Add {name} to your profile ',
    commonTitleModal: 'Friends and projects in common',
    filter: {
      search: 'Search',
      category: {
        location: 'Locations',
        origin: 'Origin',
        role: 'Function',
        degree: 'Degree',
        hashtag: '#',
      },
      location: {
        continent: 'Continent',
        country: 'Search for a country',
        region: 'States / Region',
      },
      nonLocation: {
        origin: 'Search for an origin',
        role: 'Search for a function',
        hashtag: 'Search by #',
      },
    },
    emptyData: 'No suggested contacts',
    degree1: '1st',
    degree2: '2nd',
    degree3: '3rd',
  },
  requestContact: {
    received: 'Received',
    sended: 'Sent',
  },
  menu: {
    profileButton: 'View profile',
    nonExistentProfile: 'Non-existent profile',
    share: 'Share',
    settings: 'Settings',
    signOut: 'Sign out',
    version: 'Version {version}',
  },
  contactType: {
    PRIVATE: 'Private',
    PROFESSIONAL: 'Pro',
    GROUP: 'Group',
    OTHERS: 'Others',
    GHOST: 'Ghost',
  },
  profile: {
    premiumTitle: 'Try Premium',
    mainMenus: {
      updateProfile: 'Edit Profile',
      shareProfile: 'Share Profile',
      calendar: 'Calendar',
      memories: 'Memories',
    },
    hashtags: {
      blocTitle: 'Skills',
      learn: {
        title: 'Learn',
        placeholder: 'Search your goals ...',
      },
      target: {
        title: 'Goal',
        placeholder: 'build a house ...',
      },
      hobby: {
        title: 'Hobby',
        placeholder: '# do karate ...',
      },
      skill: {
        title: 'Skills',
        placeholder: 'Marketing ...',
      },
      button: 'Save',
    },
    contact: {
      email: {
        title: 'Email',
      },
      phoneNumber: {
        title: 'Phone Number',
      },
      website: {
        title: 'Website',
      },
      fbProfile: {
        title: 'Facebook Profile',
      },
      instagramProfile: {
        title: 'Instagram Profile',
      },
      linkedinProfile: {
        title: 'LinkedIn Profile',
      },
      twitterProfile: {
        title: 'Twitter Profile',
      },
      availability: 'Availabiity',
      contact: 'Contact',
    },
    presentation: {
      title: 'Presentation',
    },
    question: {
      title: 'Question',
      button: 'Save',
      nationalities: {
        title: 'What are your nationalities:',
        placeholder: 'Search for a nationality...',
      },
      origins: {
        title: 'What are your origins:',
        placeholder: 'Search for an origin...',
      },
      languages: {
        title: 'What languages do you speak:',
        placeholder: 'Search for a language...',
        modal: {
          title: 'Select a country',
          search: {
            placeholder: 'Search for a country...',
          },
        },
      },
      countries: {
        title: 'Which countries have you visited:',
        placeholder: 'Search for a country...',
      },
      addLanguage: {
        title: 'Add a language',
        button: 'Save',
        language: {
          title: 'Language',
          placeholder: 'Select a language',
        },
        level: {
          title: 'Level',
          placeholder: 'Select your level',
          beginner: 'Beginner',
          intermediate: 'Intermediate',
          advanced: 'Advanced',
          expert: 'Expert',
        },
      },
    },
    livingPlaces: {
      title: 'Places of residence',
      addLivingPlace: {
        title: 'Add a place of residence',
        button: 'Save',
        country: {
          title: 'Country',
          placeholder: 'Select a country',
        },
        from: {
          title: 'From',
        },
        to: {
          title: 'To',
        },
      },
    },
    updateSuccess: 'Profile updated',
    about: {
      title: 'Learn more',
      save: 'Save',
      categories: {
        learn: {
          title: 'What do you want to learn?',
          placeholder: 'Search your goals...',
        },
        objective: {
          title: 'Objective',
          placeholder: '#build a house...',
        },
        hobby: {
          title: 'Hobby',
          placeholder: '# do karate...',
        },
        skills: {
          title: 'Skills',
          placeholder: '# Marketing...',
        },
      },
    },
  },
  search: {
    placeholder: 'Search',
    noResults: 'No results',
  },
  imageUpload: {
    fromCamera: 'Take a photo',
    fromGallery: 'Import from phone',
    cropTitle: 'Crop photo',
    cropHint: 'Drag the photo and adjust its size however you like.',
    cropZoom: 'Size',
    cropWhole: 'Whole photo',
    cropCancel: 'Cancel',
    cropConfirm: 'Confirm',
  },
  swipeable: {
    mute: 'Mute',
    pin: 'Pin',
    unpin: 'Unpin',
    delete: 'Delete',
  },
  errors: {
    "Events.OrganizerRequest.AlreadyOrganizer": "You are already an organizer.",
    "Events.OrganizerRequest.AlreadyPending": "You already have a request awaiting validation.",
    "Events.OrganizerRequest.AlreadyDecided": "This request has already been processed.",
    "Events.OrganizerRequest.NotFound": "This request could not be found.",
    "Events.OrganizerInvitation.AccountExists": "This address already has a KeepTouch account.",
    "Events.OrganizerInvitation.NotFound": "This invitation could not be found (it may have been used or cancelled).",
    "Events.Admin.InvalidPeriod": "Invalid period: the start date must be before the end date.",
    "Events.Event.NotFound": "This event could not be found. Check the link.",
    "Events.Event.InvalidDates": "The event must end after it starts.",
    "Events.Event.CapacityBelowAttendees": "Not possible: {attendeeCount} people are already registered.",
    "Events.Organizer.Required": "Only organizer accounts can manage events.",
    "Events.Organizer.NotOwner": "You are not the organizer of this event.",
    "Events.Connect.CannotAddSelf": "You cannot add yourself.",
    "Events.Attendee.NotRegistered": "Join the event to see who is attending.",
    "Events.Registration.Closed": "Registration for this event is closed.",
    "Events.Registration.Full": "This event is full.",
    "Events.Price.OutOfRange": "The price must be between {minCents} and {maxCents} cents (€0.50 – €10,000).",
    "Events.Price.LockedByPayments": "The price can no longer change (nor the event become free): people have already paid.",
    "Events.Payment.EventIsFree": "This event is free: there is nothing to pay.",
    "Events.Payment.NotFound": "This payment page could not be found.",
    "Events.Payment.Expired": "The reservation expired and the seat is no longer available.",
    "Events.Payment.NotConfigured": "Payment is not available right now.",
    "Events.EmailCode.Invalid": "Wrong or expired code. Ask for a new one.",
    "Events.EmailCode.TooManyRequests": "Too many requests. Try again in {retryAfterSeconds} seconds.",
    "Events.EmailCode.AccountNotFound": "No KeepTouch account uses this email.",
    "Events.Event.LocationRequired": "Enter the venue name for this event.",
    "Events.Event.OnlineUrlRequired": "Enter the video call link.",
    "Events.Event.InvalidRegistrationDeadline": "The registration deadline must be in the future.",
    "Events.Event.AlreadyEnded": "This event has already ended: pick an end date in the future.",
    "Events.Event.InvalidCoordinates": "Fill in both latitude and longitude, or neither.",
    "Events.Attendance.EventEnded": "The event is over: you can no longer unregister.",
    "Events.CoverImage.Invalid": "Image rejected: use a JPEG, PNG or WebP of 8 MB maximum.",
    "Events.LinkedIn.SignInFailed": "LinkedIn sign-in failed. Try again or sign up without LinkedIn.",
    "Events.LinkedIn.NotConfigured": "LinkedIn sign-in is not available yet. Sign up without LinkedIn.",
    "Events.Emailing.DailyLimitReached": "Daily limit reached for this event ({limit} sends per day maximum). Try again tomorrow.",
    title: 'A problem has occurred',
    logError: 'Please log in again',
    sessionExpired: 'Your session has expired. Please log in again.',
    sessionCheckFailed: 'Unstable connection: trying again in a moment.',
    generic: 'Something went wrong. Please try again.',
    invalidEmail:
      'This email address looks incomplete or mistyped (example: name@example.com).',
    tooManyRequests: 'Too many attempts. Wait a few minutes and try again.',
    'Global.ResourceNotFoundError': 'Resource not found.',
    'Global.OperationNotAllowed': 'Operation not allowed.',
    'Global.PermissionDenied': "You don't have permission to do this.",
    'Global.ResourceDeletionNotAllowed': 'This resource cannot be deleted.',
    'Identity.Authentication.Unauthenticated': 'Please sign in again.',
    'Identity.SignIn.InvalidCredentials': 'Wrong email or password.',
    'Identity.Authentication.PasswordNotSet': "This account has no password yet: sign in with a code sent by email.",
    'Identity.DeleteAccount.PasswordRequired': "To delete your account, first create a password (Settings): it is used to confirm the deletion.",
    'Identity.Password.AlreadySet': "This account already has a password. Use “Forgot password” to change it.",
    'Identity.SignUp.EmailAlreadyTaken': 'This email is already taken.',
    'Identity.ResetPassword.InvalidOrExpiredToken': 'The reset link is invalid or has expired.',
    'Networking.ContactRequest.SelfContactRequest':
      'You cannot send a contact request to yourself.',
    'Networking.ContactRequest.AlreadyExists': 'A contact request already exists with this person.',
    'Networking.ContactRequest.NotFound': 'Contact request not found.',
    'Keeptouch.ContactRequest.OnlyRecipientCanAnswer':
      'Only the person who received the request can answer it.',
    'Networking.Avatar.InvalidImage': 'This image is not valid.',
    'Networking.Note.SharedNoteRequiresContact': 'A shared note must be linked to a contact.',
    'Networking.Note.CannotShareWithSelf': 'You cannot share a note with yourself.',
    'Networking.Note.CanOnlyShareWithContacts': 'A note can only be shared with one of your contacts.',
    'Networking.Note.OnlyAuthorCanUpdate': 'Only the author of a note can edit it.',
    'Networking.Note.OnlyCreatorOrContactCanUpdate':
      'Only the creator or related contact can update this note.',
    'Networking.Note.SharedNoteContactMustDifferFromAuthor':
      "A shared note's contact must differ from the author.",
    'Networking.KeepContact.OnlyCreatorCanUpdate': 'Only the creator can update this reminder.',
    'Networking.KeepContact.ContactNotFound': 'Contact not found.',
    'Networking.KeepContact.ContactAlreadyHasFollowUp': 'This contact already has a follow-up.',
    'Networking.CalendarEvent.OnlyCreatorCanUpdate': 'Only the creator can update this event.',
    'Networking.CalendarEvent.OnlyCreatorCanDelete': 'Only the organiser can delete this event.',
    'Networking.CalendarEvent.TitleRequired': 'Please give the appointment a name.',
    'Networking.CalendarEvent.SomeParticipantsNotFound': 'Some participants were not found.',
    'Networking.ScheduledMessage.RecipientOrGroupRequired': 'Please select a recipient or a group.',
    'Networking.ScheduledMessage.GroupNotFoundOrNotMember':
      'Group not found or you are not a member.',
    'Networking.ScheduledMessage.OnlyCreatorCanUpdate':
      'Only the creator can update this scheduled message.',
    'Networking.ScheduledMessage.ContactNotFound': 'Contact not found.',
    'Networking.Group.NotFoundOrNotMember':
      'This group no longer exists, or you are not in it.',
    'Networking.Contact.NotFound': 'This person is not one of your contacts.',
    'Networking.UpdateContactScope.GhostNotAllowed': 'Scope can only be changed for real contacts.',
    'Networking.Profile.OnlyOwnerCanUpdate': 'Only the profile owner can update it.',
    'Networking.Hashtag.OnlyCreatorCanUpdate': 'Only the creator can update this hashtag.',
    'Networking.Contact.ProfileNotFound': 'Contact profile not found.',
    'Networking.Contact.RelationshipNotFound': 'Contact relationship not found.',
    'Networking.GhostProfile.NotFound': 'Ghost profile not found.',
    'Networking.GhostProfile.NoEmail': 'This ghost profile has no email on file.',
    'Networking.MergeContacts.GhostNotFoundOrNotOwned':
      'Ghost profile not found or not owned by you.',
    'Networking.MergeContacts.RealContactNotFound': 'Real contact not found in your contacts.',
    'Networking.MergeGhostProfiles.SameProfile': 'A ghost profile cannot be merged with itself.',
    'Networking.MergeGhostProfiles.GhostNotFoundOrNotOwned': 'This ghost profile no longer exists.',
    'Networking.Profile.NotFoundOrNoRelationship': 'Profile not found or no contact relationship.',
    'Networking.Conversation.NotFound': 'Conversation not found.',
    'Ft.Chatbot.ConfirmFailed':
      'The assistant could not confirm the result. Check your notes or contacts to see whether the action was done before trying again.',
    'Ft.Chatbot.ChatFailed': 'Processing the chatbot message failed.',
    'Ft.VoiceNote.NoAudioFile': 'No audio file provided.',
    'Ft.VoiceNote.ProcessingFailed': 'Processing the voice note failed.',
    'Ft.ConversationAi.AnalyzeFailed': 'Analyzing the conversation failed.',
    'Ft.ConversationAi.GenerateFailed': 'Generating suggestions failed.',
    'Ft.ConversationAi.SummarizeFailed': 'Summarizing the conversation failed.',
    'Ft.BusinessCard.NoImageFile': 'No image provided.',
    'Ft.BusinessCard.ScanFailed': 'Scanning the business card failed.',
    'Ft.SocialImport.ImportNotFound': 'Import not found.',
    'Ft.SocialImport.ResultsNotReady': 'Import results are not ready yet.',
    'Ft.SocialImport.ResultsExpired': 'The results of this import are no longer available, start the import again.',
    'Ft.SocialImport.NetworkNotEnabled': 'Network "{network}" is not enabled or configured.',
    'Ft.SocialImport.UnsupportedNetwork': 'Network "{network}" is not supported.',
    'Ft.SocialImport.NotInSucceededStatus': 'The import did not complete successfully.',
    'Ft.NearbyVisibility.UpdateFailed': 'Failed to update nearby visibility.',
    'Ft.Translate.Failed': 'Translation failed.',
    'Notifications.DeviceAlreadyRegistered': 'This device is already registered for notifications.',
    PLAN_LIMIT_CONTACTS_REACHED:
      'You’ve reached the free plan limit of {limit} contacts. Upgrade to Keeptouch Infinity for unlimited contacts.',
    PLAN_LIMIT_GHOST_PROFILES_REACHED:
      'You’ve reached the free plan limit of {limit} ghost profiles. Upgrade to Keeptouch Infinity for unlimited ghost profiles.',
    PLAN_LIMIT_NOTES_REACHED:
      'You’ve reached the free plan limit of {limit} notes. Upgrade to Keeptouch Infinity for unlimited notes.',
    PLAN_LIMIT_REMINDERS_REACHED:
      'You’ve reached the free plan limit of {limit} reminders. Upgrade to Keeptouch Infinity for unlimited reminders.',
    PLAN_FEATURE_REMINDERS_DISABLED:
      'Reminders are a Keeptouch Infinity feature. Upgrade to Keeptouch Infinity so you never forget to keep in touch.',
    PLAN_FEATURE_EXPORT_DISABLED:
      'Exporting your contacts is a Keeptouch Infinity feature. Upgrade to Keeptouch Infinity to take them anywhere.',
    PLAN_FEATURE_UNIPILE_DISABLED:
      'Connecting your networks and calendar is a Keeptouch Infinity feature. Upgrade to Keeptouch Infinity to sync everything.',
    PLAN_LIMIT_CARD_SCANS_REACHED:
      'The free plan allows {limit} card scans a month. Upgrade to Keeptouch Infinity to scan without limit.',
    PLAN_FEATURE_CARD_SCAN_DISABLED:
      'Business card scanning is a Keeptouch Infinity feature.',
    AI_DAILY_LIMIT_REACHED:
      'You’ve reached the limit of {limit} AI requests per 24 hours. It renews by itself.',
    APIFY_DAILY_LIMIT_REACHED:
      'You’ve reached the daily limit of imports and profile look-ups ({limit} per 24 hours). It renews by itself.',
    APIFY_IMPORT_ALREADY_RUNNING:
      'An import of this profile is already running. Wait until it is finished.',
  },
  common: {
    today: 'Today',
    tomorrow: 'Tomorrow',
    statusOverdue: 'Past',
    statusUpcoming: 'Upcoming',
    statusDone: 'Done',
    all: 'All',
    cancel: 'Cancel',
    add: 'Add',
    save: 'Save',
    back: 'Back',
    edit: 'Edit',
    delete: 'Delete',
    confirmDelete: 'Confirm deletion',
    choose: 'Choose',
    validate: 'Validate',
    private: 'Private',
    pro: 'Pro',
    group: 'Group',
    personCount: '{count, plural, one {# person} other {# people}}',
    resultsCount: '{count, plural, one {# result} other {# results}}',
    contactCount: '{count, plural, one {# contact} other {# contacts}}',
    memberCount: '{count, plural, one {# member} other {# members}}',
    parenCount: ' ({count})',
    selectedCount: '{count} selected',
    shared: 'Shared',
    personal: 'Personal',
    filter: 'Filter',
    momentFilterAll: 'All',
    momentFilterToday: 'Today',
    momentFilterWeek: 'This week',
    momentFilterMonth: 'This month',
    momentFilterLater: 'Later',
    scanBusinessCard: 'Scan a business card',
    inCommon: 'In common',
    viewMyProfile: 'View my profile',
    view: 'View',
    retry: 'Retry',
  },
  featureTooltip: {
    gotIt: 'Got it',
    conversation_ai_panel: {
      description:
        'Suggest: generates a reply. Summarize: a short overview. Analyze: sentiment and topics.',
    },
    scheduled_messages: {
      title: 'Scheduled messages',
      description:
        'Schedule messages to send later. AI can draft the message for you based on the reason (birthday, checking in…). Swipe to edit or delete.',
    },
    scheduled_msg_reason: {
      title: 'AI generation',
      description:
        'Choose a reason and add optional details. AI will write a personalized message suited to the context and your relationship with the contact.',
    },
    nearby_intro: {
      title: 'Contacts nearby',
      description:
        'See which contacts are near you, in the same city or country. Your location is updated automatically once a day.',
    },
    keep_contact: {
      title: 'Contact reminders',
      description:
        'Set reminders so you never forget to reach out again. Pick a date, recurrence, and filter by category or hashtag. Overdue reminders appear in red.',
    },
    graph_intro: {
      title: 'Relationship graph',
      description:
        'Explore your contacts and how they connect visually. Zoom, pan, and tap a contact to open their profile. Switch to Full mode to see links by category, hashtag, city…',
    },
    listing_contacts: {
      title: 'Your contacts',
      description:
        'Filter by Private or Pro using the tabs. Use + to add a contact manually, scan a business card, or import from a social network.',
    },
    card_scanner: {
      title: 'Business card scanner',
      description:
        'Take a photo or import a business card. AI will extract the details and create a new contact automatically.',
    },
    social_import: {
      title: 'Social contact import',
      description:
        'Pick a social network and enter a username. AI will import followers or contacts from that profile into your address book.',
    },
    merge_intro: {
      title: 'Merge duplicates',
      description:
        'KeepTouch spots the cards that have the same name, email or phone as a contact. Swipe right to merge (you are asked to confirm before any merge), left to skip. Tap a profile to review it before you decide.',
    },
    classify_swipe: {
      title: 'Classify your contacts',
      description:
        'Swipe left for Private, right for Pro. You can also use the buttons. Tap the card to open the profile.',
    },
    chatbot_intro: {
      title: 'AI assistant',
      description:
        'Ask questions about your contacts, get suggestions, or take actions like creating a note or a contact card. AI can search, analyze, and act for you.',
    },
  },
  graphScreen: {
    title: 'Relationship graph',
    nativeWebOnlyBody: 'Graph visualization is available on the web version.',
    nativeWebOnlySubtext:
      'Sign in on app.keeptouch.co from a computer to explore your relationships interactively.',
    loadingGraph: 'Loading graph…',
    mode: 'Mode',
    modeContacts: 'Contacts',
    modeFull: 'Full',
    relations: 'Relations',
    statsLine: '{nodeCount} nodes · {edgeCount} links',
    edgeContact: 'Contacts',
    edgeCategory: 'Categories',
    edgeHashtag: 'Hashtags',
    edgeProfession: 'Professions',
    edgeNationality: 'Nationalities',
    edgeCity: 'Cities',
    legendMe: 'Me',
    legendPrivate: 'Private',
    legendPro: 'Pro',
    legendGhost: 'Ghost',
    legendCategory: 'Category',
    legendHashtag: 'Hashtag',
    legendProfession: 'Profession',
    legendNationality: 'Nationality',
    legendCity: 'City',
    searchPlaceholder: 'Search in the graph',
    loadError: 'An error occurred. Try again.',
  },
  geolocation: {
    unavailable: {
      title: 'Geolocation unavailable',
      message: 'Geolocation is not available on this device.',
    },
    denied: {
      title: 'Permission denied',
      message:
        'We need access to your location to provide you with a better experience. Would you like to open settings to enable geolocation?',
      cancel: 'Cancel',
      settings: 'Settings',
    },
    blocked: {
      title: 'Permission blocked',
      message:
        'Access to geolocation has been blocked. Please go to the app settings to enable it manually.',
      cancel: 'Cancel',
      settings: 'Settings',
    },
  },
  contacts: {
    searchProfile: 'Search for a profile',
    addNonExistingProfile: 'Add a non-existing profile',
    importFromContacts: 'Import from my contacts',
    importFrom: 'Import from {network}',
    uncontact: 'Remove from my contacts',
    uncontactConfirmTitle: 'this contact',
  },
  settings: {
    notifications: 'Notifications',
    notificationsDescription: 'Choose when your phone lets you know.',
    title: 'Settings',
    language: 'Language',
    languageDescription: 'Choose the application language',
    auto: 'Automatic (device language)',
    french: 'Français',
    english: 'English',
    spanish: 'Español',
    location: 'Location',
    locationDescription: "This device's permission, and who sees your position",
    locationPermission: "This device's permission",
    locationPermissionGranted: 'Granted',
    locationPermissionDenied: 'Denied',
    locationPermissionUndetermined: 'Not asked yet',
    locationPermissionUnknown: 'Cannot be checked',
    locationAllow: 'Allow',
    locationVisibility: 'Who sees my position',
    locationDenied: 'Location blocked by the browser. Allow it for this site.',
    locationDeniedApp: 'Location refused. Allow it in the phone settings.',
    openPhoneSettings: 'Phone settings',
    subscription: 'Subscription',
    subscriptionDescription: 'Your current KeepTouch plan',
    legal: 'Legal information',
    legalDescription: 'Legal notice, privacy and contact.',
    subscriptionFree: 'Free plan',
    subscriptionManage: 'See Premium plans',
    subscriptionPremium: 'Premium active',
    calendarSync: 'Calendar sync',
    calendarSyncDescription: 'Add your KeepTouch events to your phone calendar.',
    calendarSyncEnable: 'Sync with my calendar',
    calendarSyncPermissionDenied: 'Calendar permission is required to sync.',
    deleteAccountTitle: 'Delete my account',
    deleteAccountDescription:
      'Permanently deletes your account and all your data. This action cannot be undone.',
    deleteAccountButton: 'Delete my account',
    deleteAccountConfirmTitle: 'Delete your account?',
    deleteAccountConfirmMessage:
      'This is permanent: your account and all your data (contacts, notes, messages…) will be deleted. You will not be able to recover them.',
    deleteAccountCancel: 'Cancel',
    deleteAccountConfirm: 'Delete permanently',
    deleteAccountInProgress: 'Deleting…',
    deleteAccountPasswordPlaceholder: 'Enter your password',
    deleteAccountWrongPassword: 'Incorrect password.',
    deleteAccountError: 'Account deletion failed. Please try again.',
    deleteAccountNeedPassword: 'To delete your account, first create a password: it is used to confirm the deletion.',
    deleteAccountCreatePassword: 'Create a password',
  },
  calendarModal: {
    month0: 'January',
    month1: 'February',
    month2: 'March',
    month3: 'April',
    month4: 'May',
    month5: 'June',
    month6: 'July',
    month7: 'August',
    month8: 'September',
    month9: 'October',
    month10: 'November',
    month11: 'December',
    weekDay0: 'MON',
    weekDay1: 'TUE',
    weekDay2: 'WED',
    weekDay3: 'THU',
    weekDay4: 'FRI',
    weekDay5: 'SAT',
    weekDay6: 'SUN',
    time: 'Time',
    schedule: 'Schedule',
    subscriptionManage: 'See Premium plans',
    subscriptionPremium: 'Premium active',
  },
  connectedServices: {
    sectionTitle: 'Connected services',
    sectionDescription:
      'Connect your messaging accounts to automatically import your contacts into KeepTouch.',
    connect: 'Connect',
    connected: 'Connected',
    reconnect: 'Reconnect',
    statusConnecting: 'Connecting…',
    wizardOpened: 'Finish connecting in the tab that just opened, then come back here.',
    disconnect: 'Disconnect',
    disconnected: 'Service disconnected.',
    disconnectError: 'Disconnecting failed, please try again.',
    wizardError: 'Could not create the connection link, please try again.',
    refresh: 'Refresh',
    filterPlaceholder: 'Filter (optional): e.g. cybersecurity, finance, recruiting…',
    syncFilteredOut: '{filtered} contact(s) outside the filter were not imported',
    syncTruncated: 'Only the first 500 contacts of this service were read.',
    syncStarted: 'Import started — this can take a few minutes. No need to disconnect the service, it\u2019s coming! ⏳',
    syncInProgressHint: 'Import in progress… This can take a few minutes, you can keep using the app.',
    syncNow: 'Import my contacts',
    syncing: 'Importing…',
    syncResult: '{created} contact(s) imported, {skipped} already there',
    syncEmpty: 'No new contacts to import',
    syncError: 'The import failed, please try again.',
    planLimit: 'Free plan limit reached — some contacts were not imported.',
    noAccounts: 'No service connected yet.',
    serviceInstagram: 'Instagram',
    serviceWhatsapp: 'WhatsApp',
    serviceLinkedin: 'LinkedIn',
    serviceGmail: 'Gmail',
    calendarSync: 'Sync Google Calendar',
    calendarSyncing: 'Syncing…',
    calendarConnect: 'Connect Google Calendar',
    calendarSyncResult: '{created} event(s) imported, {skipped} already there',
    calendarSyncEmpty: 'Calendar already up to date',
    calendarSyncError: 'The sync failed, please try again.',
  },
  subscription: {
    title: 'Subscription',
    headline: 'Choose your Keeptouch experience',
    intro: 'Two plans to grow and nurture your human network, at your own pace.',
    // Free tier
    freeTierTitle: 'Free version',
    freeTierSubtitle: 'To discover Keeptouch and organize your first contacts.',
    freePriceLabel: 'Free',
    freeFeatureContacts: 'Up to {count} contacts',
    freeFeatureGhosts: '{count} ghost profiles',
    freeFeatureNotes: '{count} personal notes',
    freeFeatureReminders: '{count} keep-in-touch reminders',
    // Keeptouch Infinity
    infinityTierTitle: 'Keeptouch Infinity',
    infinityTierSubtitle: 'The complete experience for human-network builders.',
    infinityBadge: 'Recommended',
    infinityPriceFallback: '€6.99/month',
    infinityPricePerMonth: '{price}/month',
    infinityFeatureContacts: 'Unlimited contacts and ghost profiles',
    infinityFeatureNotes: 'Unlimited personal notes',
    infinityFeatureReminders: 'Unlimited keep-in-touch reminders',
    infinityFeatureIntegrations: 'Connect your networks and your calendar',
    infinityFeatureExport: 'Export of your contacts (.vcf)',
    infinityCta: 'Start Keeptouch Infinity',
    comingSoon: 'Coming soon',
    comingSoonMessage: 'Keeptouch Infinity is coming very soon. Thanks for your patience!',
    premiumTitle: 'You are Infinity',
    premiumSubtitle: 'Thanks for being part of Keeptouch Infinity. You enjoy every feature, with no limit.',
    premiumActive: 'Active subscription',
    expiresOn: 'Renews on {date}',
    endsOn: 'Your subscription ends on {date}',
    offeredUntil: 'Complimentary access until {date}',
    currentPeriodUntil: 'Current period until {date}',
    processing: 'Processing…',
    activating: 'Activating your subscription…',
    activationPendingTitle: 'Payment received',
    activationPendingMessage:
      'Activation can take a few minutes. This page will update by itself.',
    purchaseSuccessTitle: 'Welcome to Keeptouch Infinity',
    purchaseSuccessMessage: 'Your subscription is active. Enjoy every feature!',
    purchaseErrorTitle: 'Purchase failed',
    purchaseErrorMessage: 'The purchase could not be completed. Please try again.',
    restoreCta: 'Restore purchases',
    restoring: 'Restoring…',
    restoreSuccessTitle: 'Subscription restored',
    restoreSuccessMessage: 'Your Infinity subscription has been restored.',
    restoreNoneTitle: 'Nothing to restore',
    restoreNoneMessage: 'We couldn’t find an active subscription on this account.',
    restoreErrorTitle: 'Restore failed',
    restoreErrorMessage: 'The restore could not be completed. Please try again.',
    manageCta: 'Manage my subscription',
    manageErrorTitle: 'Could not open',
    manageErrorMessage: 'Could not open the subscription management page.',
    cancelCta: 'Cancel my subscription',
    cancelConfirmQuestion: 'Are you sure you want to cancel your subscription?',
    cancelConfirmUntilDate:
      'You will keep every Keeptouch Infinity feature until {date}, then your account will switch back to the free plan.',
    cancelConfirmUntilPeriodEnd:
      'You will keep every Keeptouch Infinity feature until the end of the period already paid, then your account will switch back to the free plan.',
    cancelConfirmYes: 'Yes, cancel my subscription',
    cancelConfirmNo: 'No, keep my subscription',
    cancelOfferedTitle: 'Complimentary subscription',
    cancelOfferedMessage:
      'Your Keeptouch Infinity access was given to you: there is no payment in progress, so there is nothing to cancel.',
    cancelUnavailableTitle: 'Cancellation unavailable right now',
    cancelUnavailableMessage:
      'We couldn’t open the page to cancel your subscription. Please try again in a moment.',
    legalDisclosure:
      'Auto-renewable monthly subscription at €6.99/month. It renews automatically unless cancelled at least 24 hours before the end of the period. You can cancel anytime in your account settings.',
    termsOfUse: 'Terms of Use',
    privacyPolicy: 'Privacy Policy',
  },
  planLimit: {
    title: 'Upgrade to Keeptouch Infinity',
    body: 'You’ve reached a free plan limit. Upgrade to Keeptouch Infinity to unlock this feature.',
    upgrade: 'Upgrade to Keeptouch Infinity',
    later: 'Maybe later',
    close: 'Close',
    noCommitment: 'No commitment',
    cancelAnytime: 'Cancel anytime',
    included: 'What’s included',
  },
  export: {
    sectionTitle: 'Export my contacts',
    sectionDescription:
      'Download all your contacts as a vCard (.vcf) file, importable into any address book.',
    cta: 'Export my contacts (.vcf)',
    exporting: 'Exporting…',
    successTitle: 'Export complete',
    successMessage: 'Your contacts were exported as a vCard.',
    emptyTitle: 'No contact to export',
    emptyMessage: 'Add contacts, then run the export again.',
  },
  eventsExport: {
    sectionTitle: 'My events data',
    sectionDescription:
      'Download your registrations, attendance, payments, invitations received, contacts added from an event, and organizer requests, for free.',
    ctaJson: 'Export (JSON)',
    ctaCsv: 'Export (CSV spreadsheet)',
    exporting: 'Exporting…',
    successTitle: 'Export complete',
    successMessage: 'Your events data was exported.',
  },
  recurrence: {
    title: 'Recurrence',
    custom: 'Custom',
    recurrence: 'Recurrence',
    every: 'Every',
    everyDay: 'Every day',
    everyWeek: 'Every week',
    every2Weeks: 'Every 2 weeks',
    every6Weeks: 'Every 6 weeks',
    everyMonth: 'Every month',
    every3Months: 'Every 3 months',
    every6Months: 'Every 6 months',
    everyYear: 'Every year',
    repeatOn: 'Repeat on',
    end: 'End',
    never: 'Never',
    on: 'On',
    after: 'After',
    lastDayOfMonth: 'Last day of month',
    day: 'day',
    week: 'week',
    month: 'month',
    year: 'year',
    repetition: 'repetition',
  },
  calendarEvent: {
    createEvent: 'Create an appointment',
    editEvent: 'Edit appointment',
    shared: 'Shared',
    sharedCount: 'Shared',
    personal: 'Personal',
    eventName: 'Appointment name',
    eventNamePlaceholder: 'Appointment name...',
    addGuests: 'Add guests',
    searchGuests: 'Search guests...',
    addPeoplePrivate: 'People concerned',
    searchPeoplePrivate: 'Search for a person...',
    privatePeopleHint: 'They are not told and cannot see this appointment.',
    eventDate: 'Event date',
    allDay: 'All day',
    addLocation: 'Add a location',
    locationTitle: 'Location',
    description: 'Description',
    descriptionPlaceholder: 'Description...',
    alert: 'Alert',
    alertEnabled: 'Alert enabled',
    noAlert: 'No alert',
    inviteAndAdd: 'Invite and add to KeepTouch',
    addToCalendar: 'Add only to KeepTouch',
    addToGoogle: 'Add to Google Calendar',
    deleteConfirm: 'Delete this appointment?',
    markAsDone: 'Mark as done',
    markAsNotDone: 'Mark as not done',
    birthdayOn: 'Birthday: {date}',
    keepContactPlannedOn: 'Keep in touch: reminder on {date}',
    titleRequired: 'Please give the appointment a name.',
    endBeforeStart: 'The appointment ends before it starts.',
  },
  ghostProfile: {
    inviteToJoin: 'Invite to join',
    inviteSent: 'Invitation sent by email.',
    inviteAgain: 'Invite again',
    inviteConfirmTitle: 'Invite {name}?',
    inviteConfirmBody:
      'An invitation e-mail will be sent to {email}, with a link to create an account and find you on KeepTouch.',
    inviteConfirmAgain:
      'You already invited {name} on {date}. Send the invitation to {email} again?',
    inviteSend: 'Send',
    inviteError: 'Could not send the invitation. Please try again.',
    inviteErrorNoEmail: 'This profile has no email address. Add an email to send an invitation.',
    editProfile: 'Edit profile',
    about: 'About',
    presentation: 'Presentation',
    birthday: 'Birthday',
    languages: 'Languages',
    nationalities: 'Nationalities',
    origins: 'Origins',
    contactInfo: 'Contact info',
    email: 'Email',
    phone: 'Phone',
    website: 'Website',
    availabilities: 'Availabilities',
    livedPlaces: 'Lived places',
    categories: 'Categories',
    searchCategories: 'Search categories',
    keepContact: 'Keep in touch',
    context: 'Context',
    hashtag: 'Hashtag',
    searchHashtags: 'Search hashtags',
    hashtags: 'Hashtags',
    objectives: 'Objectives',
    hobby: 'Hobby',
    skills: 'Skills',
    notes: 'Notes',
    appointments: 'Appointments / Reminders',
    memories: 'Memories',
    shareProfile: 'Share',
    message: 'Message',
    requestSent: 'Request sent',
    openOnKeepTouch: 'Open on KeepTouch',
    edit: 'Edit',
    deleteProfile: 'Delete profile',
    deleteConfirmTitle: 'this ghost profile',
    deleteConfirmMessage:
      'Delete this ghost profile? The notes and follow-ups linked to this person will be permanently deleted with it. This cannot be undone.',
    deleteSuccess: 'Ghost profile deleted',
    updateSuccess: 'Ghost profile updated',
    createSuccess: 'Ghost profile created',
    lastInteraction: 'Last interaction {time}',
    noInteractionYet: 'No interaction yet',
    viewMyProfile: 'View my profile',
    aboutProfile: 'About the profile',
    pins: 'Pins',
    strangerNotice: 'Add {name} to your contacts to see the rest of their profile.',
    strangerNoticePending:
      "The rest of {name}'s profile will show once your request is accepted.",
    strangerNoticeReceived:
      '{name} would like to add you to their contacts. Accept the request to see the rest of their profile.',
    cancelRequest: 'Cancel request',
    cancelRequestHeading: 'Cancel request',
    cancelRequestTitle: 'Cancel the request sent to {name}?',
    notFoundTitle: 'Profile not found',
    notFoundMessage:
      'This link or QR code does not match any profile. It may be outdated, or the account may have been deleted.',
    loadErrorTitle: 'Unable to load this profile',
    loadErrorMessage: 'Check your connection and try again.',
  },
  contextes: {
    title: 'Contexts',
    meetingContext: 'Meeting context',
    associatedEmotion: 'Associated emotion',
    relationshipEvolution: 'Relationship evolution',
    relationshipAutomatic: 'Worked out automatically from your messages',
    associatedColor: 'Associated color',
    referencePlace: 'Reference place',
    enterPlace: 'Enter a place',
    chooseMeetingContext: 'Choose the meeting context',
    editMeetingContext: 'Edit the meeting context',
    chooseEmotion: 'Choose the associated emotion',
    editEmotion: 'Edit the associated emotion',
    chooseRelationship: 'Choose the relationship evolution',
    editRelationship: 'Edit the relationship evolution',
    chooseColor: 'Choose the associated color',
    editColor: 'Edit the associated color',
    searchMeetingContext: 'Search a meeting context',
    searchEmotion: 'Search an associated emotion',
    searchRelationship: 'Search a relationship evolution',
    searchColor: 'Search an associated color',
    save: 'Save',
    unsavedTitle: 'Unsaved changes',
    unsavedMessage: "Are you sure you don't want to save?",
    leaveWithoutSaving: 'Leave without saving',
    keepEditing: 'Cancel',
  },
  categories: {
    notFound: 'Category not found',
    gallery: 'Gallery',
    camera: 'Camera',
    person: 'person',
    persons: 'persons',
  },
  importContacts: {
    back: 'Back',
    importCard: 'Import a business card',
    businessCard: 'Business card',
    dragCard: 'Drag the business card here',
    or: 'Or',
    selectFiles: 'Select from your files',
    supportedFormats: 'Supported formats: PDF, JPEG, PNG',
    startImport: 'Start import',
    contactFound: 'Contact found on KeepTouch',
    profileFound: 'Profile found!',
    addNewContact: 'Add a new contact:',
    validate: 'Save the profile',
    validating: 'Saving…',
    checkInfo: 'Check the imported information',
    alreadySaved: 'This contact is already in your list. “Save the profile” saves your corrections.',
    discard: 'Do not keep this contact',
    firstName: 'First name',
    enterFirstName: 'Enter first name',
    lastName: 'Last name',
    enterLastName: 'Enter last name',
    profession: 'Profession',
    enterProfession: 'Enter profession',
    company: 'Company',
    enterCompany: 'Enter company',
    email: 'Email',
    phone: 'Phone',
    address: 'Address',
    website: 'Website',
    hashtag: 'Hashtag',
    hashtagPlaceholder: 'Name of #...',
    categoriesLabel: 'Categories',
    searchProfession: 'Search a profession',
    file: {
      title: 'Import from a CSV file',
      subtitle:
        'Drop a CSV export from your CRM or Google Contacts: you check the columns, then a ghost profile is created for each contact that is not already in yours.',
      drag: 'Drag your file here',
      formats: 'Supported format: CSV (.csv)',
      fullName: 'Full name',
      linkedin: 'LinkedIn',
      instagram: 'Instagram',
      facebook: 'Facebook',
      twitter: 'Twitter / X',
      notes: 'Notes',
      unsupportedFormat: 'Unsupported format. Please choose a CSV (.csv) file. Export Excel files to CSV first.',
      empty: 'The file does not contain any contact rows.',
      parseError: 'Could not read the file. Make sure it is a valid CSV file.',
      detected: '{count} contact(s) detected in the file',
      columnsDetected: 'Check the columns before importing:',
      columnsTitle: 'Columns of the file',
      ignoreColumn: 'Ignore',
      sample: 'Example: {value}',
      previewTitle: 'Preview',
      noUsableRows: 'No usable rows: at least a name, email or phone is required.',
      importButton: 'Import {count} contact(s)',
      importing: 'Creating profiles… {done} / {total}',
      doneTitle: '{count} contact(s) imported successfully',
      doneDuplicates: '{count} already in your contacts, not imported again',
      doneIgnored: '{count} row(s) skipped: no name, email or phone',
      doneFailed: '{count} contact(s) refused:',
      doneLimit: 'Limit of your plan reached: {count} contact(s) not imported',
      failureLine: 'Contact no. {row} — {name}: {reason}',
      moreFailures: 'and {count} more',
      importAnother: 'Import another file',
      importedToast: '{count} ghost profile(s) created',
    },
  },
  contactsList: {
    noContactFound: 'No contact found',
    contactViaSocial: 'Contact via social networks',
  },
  socialNetwork: {
    contactViaLinkedin: 'Contact via LinkedIn',
    contactViaFacebook: 'Contact via Facebook',
    contactViaInstagram: 'Contact via Instagram',
    contactViaTwitter: 'Contact via Twitter',
  },
  keepContact: {
    editReminder: 'Edit follow-up',
    createReminder: 'Create a follow-up',
    reminderTitle: 'Follow-up title',
    reminderTitlePlaceholder: 'Follow-up name...',
    description: 'Description',
    descriptionPlaceholder: 'Description...',
    addContact: 'Add a contact',
    searchContact: 'Search for a contact...',
    contactLabel: 'Contact',
    eventDate: 'Event date',
    addLocation: 'Add a location',
    location: 'Location',
    alert: 'Alert',
    alertEnabled: 'Alert enabled',
    noAlert: 'No alert',
    alertActive: 'Active',
    alertInactive: 'Inactive',
    backToProfile: 'Back to profile',
    pageTitle: 'Keep in touch',
    reminder: 'follow-up',
    reminders: 'follow-ups',
    statusLate: 'Late',
    deleteConfirm: 'this follow-up',
    filter: 'Filter',
    none: 'None',
    keepContactWith: 'Keep contact with {contactName}',
    listView: 'List',
    boardView: 'Board',
  },
  recurrenceComponent: {
    everyDay: 'Every day',
    everyWeek: 'Every week',
    everyMonth: 'Every month',
    everyYear: 'Every year',
    recurrence: 'Recurrence',
    every: 'Every',
    repeatOn: 'Repeat on',
    monthDetail: 'Month detail',
    lastDayOfMonth: 'Last day of month',
    end: 'End',
    never: 'Never',
    on: 'On',
    after: 'After',
    day: 'day',
    days: 'days',
    week: 'week',
    weeks: 'weeks',
    month: 'month',
    year: 'year',
    years: 'years',
    repetition: 'repetition',
    repetitions: 'repetitions',
  },
  filters: {
    title: 'Filters',
    gender: 'Gender',
    age: 'Age',
    min: 'Min',
    max: 'Max',
    ageYears: '{count} years',
    ageMin: 'Minimum age',
    ageMax: 'Maximum age',
    genderFemale: 'F',
    genderMale: 'M',
    genderNonBinary: 'NB',
    genderFemaleLong: 'Female',
    genderMaleLong: 'Male',
    genderNonBinaryLong: 'Non-binary',
    residence: 'Place of residence',
    residenceContinent: 'Continent',
    residenceCountry: 'Country',
    residenceRegion: 'Region',
    residenceCity: 'City',
    livedPlaces: 'Places lived',
    origin: 'Origin',
    nationality: 'Nationality',
    profession: 'Profession',
    meetingContext: 'Meeting context',
    associatedEmotion: 'Associated emotion',
    relationshipEvolution: 'Relationship evolution',
    associatedColor: 'Associated color',
    language: 'Language',
    category: 'Category',
    hashtag: 'Hashtag',
    searchPlace: 'Search for a place',
    activitySector: 'Activity sector',
    searchSector: 'Search for a sector',
    searchHashtags: 'Search hashtags',
    searchHashtag: 'Search for a hashtag',
    searchCategories: 'Search categories',
    searchCategory: 'Search for a category',
    searchMeetingContext: 'Search for a meeting context',
    searchEmotion: 'Search for an associated emotion',
    searchRelationship: 'Search for a relationship evolution',
    searchColor: 'Search for an associated color',
    searchLanguage: 'Search for a language',
    contact: 'Contact',
    eventDate: 'Event date',
    addPlace: 'Add a place',
    place: 'Place',
  },
  photoAlert: {
    title: 'Choose a photo',
    message: 'Select an option',
  },
  qrCode: {
    shareMessage: 'Check out my KeepTouch profile: {url}',
    shareTitle: 'My KeepTouch profile',
    error: 'Error',
    shareError: 'Unable to share profile',
    success: 'Success',
    linkCopied: 'Link copied to clipboard',
    copyError: 'Unable to copy link',
    info: 'Information',
    downloadTodo: 'Download feature to be implemented',
    downloaded: 'QR code downloaded',
    downloadError: 'Could not download the QR code',
    notKeepTouchUrl: 'This QR code does not contain a KeepTouch profile link.',
    scanTitle: 'Scan QR Code',
    scanInstruction: 'Point your camera at a KeepTouch QR code to scan it.',
    scanWebFallbackActive: 'Using alternative scanner for your browser.',
    cameraPermissionTitle: 'Camera access required',
    cameraPermissionMessage:
      'Please allow camera access in your browser settings to scan QR codes.',
    cameraPermissionMessageApp: 'Allow KeepTouch to use the camera to scan a QR code.',
    allowCamera: 'Allow camera',
    openSettings: 'Open settings',
  },
  webNav: {
    search: 'Search',
    allContacts: 'All my contacts',
    messaging: 'Messaging',
    notifications: 'Notifications',
    myProfile: 'My profile',
    signOut: 'Sign out',
    settings: 'Settings',
  },
  menuItems: {
    admin: "Administration",
    events: "Events",
    importContacts: 'Import contacts',
    classifyProfiles: 'Classify profiles',
    mergeProfiles: 'Merge profiles',
    maps: 'Maps',
    notes: 'Notes',
    categories: 'Categories',
    hashtags: 'Hashtags',
    relationalColors: 'Relational colors',
    appointments: 'Appointments / Reminders',
    birthdays: 'Birthdays',
    keepContact: 'Keep in touch',
    scheduledMessages: 'Scheduled messages',
    qrCode: 'QR code',
    settings: 'Settings',
    graph: 'Relationship graph',
    nearby: 'Nearby contacts',
  },
  form: {
    contactInfo: 'Contact info',
    about: 'About',
    woman: 'A woman',
    man: 'A man',
    mainInfo: 'Main information',
    firstName: 'First name',
    enterFirstName: 'Enter first name',
    lastName: 'Last name',
    enterLastName: 'Enter last name',
    professions: 'Profession(s)',
    enterProfession: 'Enter profession',
    company: 'Company',
    enterCompany: 'Company name (optional)',
    email: 'Email',
    phoneNumber: 'Phone number',
    socialNetworks: 'Social networks',
    website: 'Website',
    descriptionPlaceholder: 'Description...',
    presentation: 'Presentation',
    birthDate: 'Date of birth',
    livingPlace: 'Place of residence',
    origins: 'Origins',
    nationalities: 'Nationalities',
    nationalityPlaceholder: 'Nationality',
    spokenLanguages: 'Spoken languages',
    enterLanguages: 'Enter languages',
    livedPlaces: 'Lived places',
    hashtags: 'Hashtags',
    availabilityAndMeetings: 'Availability and meeting types',
    availability: 'Availability',
    bestMoment: 'Best moment',
    bestMoments: 'Best moments',
    chooseDay: 'Choose a day',
    chooseTime: 'Choose a time',
    days: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
    },
    searchLanguage: 'Search a language',
    searchPlace: 'Search a place',
    searchNationality: 'Search a nationality',
    searchHashtags: 'Search hashtags',
    searchCategories: 'Search categories',
    searchProfession: 'Search a profession',
    backToProfile: 'Back to profile',
    backToContacts: 'Back to contacts list',
    editGhostProfile: 'Edit ghost profile',
    createGhostProfile: 'Create ghost profile',
    addMeetingContext: 'Add meeting context',
    addNewProfile: 'Add a new profile',
    addContact: 'Add a contact',
    searchContact: 'Search a contact...',
    addNonExistingProfile: 'Add a non-existing profile',
  },
  messaging: {
    searchPlaceholder: 'Search a message or contact',
    groupNamePlaceholder: 'Group name (optional)',
    recipientPlaceholder: 'Enter your recipient...',
    messagePlaceholder: 'Type your message...',
    draftPending: 'Preparing your message…',
    aboutGroup: 'About the group',
    seen: 'Seen',
    photo: '📷 Photo',
    noMessages: 'No messages',
    createNewMessage: 'Create a new message',
  },
  profileEdit: {
    editMyProfile: 'Edit my profile',
    backToMyProfile: 'Back to my profile',
    about: 'About:',
    categories: 'Categories',
    searchCategories: 'Search categories',
  },
  livingPlaceForm: {
    editTitle: 'Edit place of residence',
    addTitle: 'Add place of residence',
    place: 'Place',
    startDate: 'Start date',
    endDate: 'End date',
    currently: 'Currently',
  },
  notesForm: {
    addNote: 'Add a note',
    editNote: 'Edit note',
    titlePlaceholder: 'Title',
    notePlaceholder: 'Note',
    sharedWith: 'Shared with ',
    whoCanRead: 'Who can read this note?',
    onlyMe: 'Only me',
    onlyMeSubtitle: 'Personal note',
    meAnd: 'Me and {name}',
    meAndSubtitle: '{name} will see it in the app',
    dictate: 'Dictate',
    pin: 'Pin',
    unpin: 'Unpin',
    autoSave: 'Saved automatically',
    about: 'About',
    choosePerson: 'Choose a person',
    change: 'Change',
    seeProfile: 'See profile',
    lastExchange: 'Last exchange:',
    noExchangeYet: 'No exchange yet',
    otherNotes:
      '{count, plural, =0 {No other note about {name}} one {# other note about {name}} other {# other notes about {name}}}',
    see: 'See',
    meAndThisPerson: 'Me and this person',
    chooseFirst: 'Choose a person first',
    ghostNoApp: "This profile doesn't use the app",
    notAddedBack: 'This person has not added you back yet',
    savedForMeOnly: 'This person has not added you back yet: the note is saved for you only.',
    date: 'Date',
    writtenOn: 'Written on {date}',
    todayDate: 'Today, {date}',
    allProfiles: 'All',
    allProfilesCount: 'All your profiles · {count}',
    privateCount: 'Private · {count}',
    proCount: 'Pro · {count}',
    ghostCount: 'Ghosts · {count}',
    noProfileFound: 'No profile found',
    removePerson: 'Remove the person from the note',
    pinned: 'Pinned',
    pinnedWhere: 'Pinned · in “To remember” on {name}’s profile',
    pinnedTop: 'Pinned · at the top of your notes',
    meAndSomeone: 'Me and …',
    done: 'OK',
    changePerson: 'Change person',
    noteWrittenOn: 'Note written on {date}',
    today: 'Today',
  },
  hashtagForm: {
    addTitle: 'Add a hashtag',
    editTitle: 'Edit hashtag',
    backToList: 'Back to hashtags list',
    namePlaceholder: 'Name...',
  },
  deleteModal: {
    confirmMessage: 'Are you sure you want to delete {title}?',
    delete: 'Delete',
    cancel: 'Cancel',
  },
  relationalColorForm: {
    editTitle: 'Edit relational color',
    namePlaceholder: 'Name...',
  },
  addContactModal: {
    addPerson: 'Add {name}',
    addDefaultPerson: "Add person's name",
    addPrivate: 'Add as Private',
    addProfessional: 'Add as Professional',
    requestSent: 'Request sent',
  },
  addHashtagModal: {
    title: 'Add a hashtag',
    save: 'Save',
  },
  addCategoryModal: {
    title: 'Add a category',
    save: 'Save',
  },
  menuContactsList: {
    addContacts: 'Add contacts',
    linkedContacts: 'Linked contacts',
  },
  memoriesForm: {
    addPhoto: 'Add a photo',
    editMemory: 'Edit memory',
    addMemory: 'Add a memory',
    memory: 'Memory',
    selectMemory: 'Select a memory',
    description: 'Description:',
    identifyContacts: 'Identify contacts:',
    identifiedContacts: 'Identified contacts',
    publish: 'Publish',
    sharedMemories: 'Shared memories',
    sharedAlbums: 'Shared albums',
    deleteMemoryDescription: 'Do you want to delete only this photo, or the entire album?',
    deletePhoto: 'Delete this photo',
    deleteAlbum: 'Delete the album',
    deleteAlbumDescription: 'Are you sure you want to delete this entire album?',
  },
  albums: {
    title: 'Albums',
    createAlbum: 'Create album',
    albumName: 'Album name',
    albumTitle: 'Album title',
    defaultTitle: 'My album',
    description: 'Description',
    empty: 'No albums yet',
    deleteConfirm: 'Are you sure you want to delete this album?',
  },
  creationStack: {
    addNote: 'Add a note',
    conversation: 'Conversation',
    createEvent: 'Create an event',
    addReminder: 'Add a reminder',
    scheduleMessage: 'Schedule message',
    composeMessage: 'Compose message',
  },
  calendarAddEvent: {
    notActive: 'Not active',
    active: 'Active',
  },
  toast: {
    success: 'Success',
    error: 'Error',
    info: 'Info',
    scheduledMessageDeleted: 'Scheduled message deleted',
    scheduledMessageCreated: 'Scheduled message created',
    scheduledMessageUpdated: 'Scheduled message updated',
    reminderUpdated: 'Appointment / Reminder updated',
    reminderDeleted: 'Appointment / Reminder deleted',
    reminderCreated: 'Appointment / Reminder created',
    eventDeleted: 'Event deleted',
    eventCreated: 'Event created',
    eventUpdated: 'Event updated',
    colorUpdated: 'Color updated',
    contactRequestSent: 'Request sent',
    contactRequestSentMessage: 'Your friend request has been sent.',
    contactRequestCancelled: 'Request cancelled',
    scopeChanged: 'Scope changed',
    categoryUpdated: 'Category updated',
    categoryCreated: 'Category created',
    categoryDeleted: 'Category deleted',
    noteCreated: 'Note created',
    noteUpdated: 'Note updated',
    noteDeleted: 'Note deleted',
    hashtagUpdated: 'Hashtag updated',
    hashtagDeleted: 'Hashtag deleted',
    hashtagCreated: 'Hashtag created',
    memoryCreated: 'Memory added',
    memoryUpdated: 'Memory updated',
    memoryDeleted: 'Memory deleted',
    albumCreated: 'Album created',
    albumDeleted: 'Album deleted',
  },
  voiceNote: {
    error: 'Error processing voice note',
    vocal: 'Vocal',
    successProfileUpdated: 'Profile updated',
    successNoteCreated: 'Note created',
    successProcessed: 'Voice note processed',
    micUnavailableTitle: 'Microphone unavailable',
    micUnavailableMessage:
      'Allow the microphone for KeepTouch in your browser or phone settings, then try again.',
  },
  messagesScreen: {
    private: 'Private',
    pro: 'Pro',
    groups: 'Groups',
    other: 'Other',
    pinnedMessages: 'View pinned messages',
    viewNotes: 'View notes',
    viewMedia: 'View media',
    viewMembers: 'View members',
    customizeGroup: 'Customize group',
    share: 'Share',
    block: 'Block',
    report: 'Report',
    group: 'Group',
    members: 'Members',
    persons: '{count} people',
  },
  contactsScreen: {
    personFound: 'person found',
    personsFound: 'people found',
    noContactFound: 'No contact found',
    professionNotSpecified: 'Profession not specified',
    profilesRemainingToMerge: 'profiles remaining to merge',
    profileRemainingToMerge: 'profile remaining to merge',
    noProfileToMerge: 'No profile to merge',
    mergeProfiles: 'Merge profiles',
    merge: 'Merge',
    swipeToMerge: 'Swipe right to merge, left to skip.',
    swipeMergeInstruction: 'Swipe right to merge, left to skip.',
    profilesRemainingToClassify: 'profiles remaining to classify',
    profileRemainingToClassify: 'profile remaining to classify',
    noProfileToClassify: 'No profile to classify',
    classifyAgain: 'Sort everything again',
    classifyProfiles: 'Classify profiles',
    swipeToClassify: 'Swipe right or left to set the contact as professional or private.',
    swipeClassifyInstruction: 'Swipe right or left to set the contact as professional or private.',
    import: 'Import',
    importContacts: 'Import contacts',
    importAll: 'Import all',
    allContactsImported: 'All contacts have been imported',
    pleaseSyncContacts: 'Please sync your contacts',
    allImported: 'All contacts have been imported',
    syncContacts: 'Sync my contacts',
    selected: 'selected',
    contactFound: 'Contact found!',
    profileFound: 'Profile found!',
    contactFoundScan: 'Contact found!',
    profileFoundScan: 'Profile found!',
  },
  profileScreen: {
    noLivingPlaceAdded: 'No place of residence added',
    pressToAddFirstPlace: 'Tap + to add your first place',
    tapToAddFirstPlace: 'Tap + to add your first place',
    noDataAdded: 'No data added',
    noAvailabilityAdded: 'No availability added',
    noContactInfoAdded: 'No contact info added',
    noHashtagAdded: 'No hashtag added',
    backToMyProfile: 'Back to my profile',
    aboutSection: 'About:',
    uploadMemory: 'Upload your memory:',
    selectMemory: 'Select a memory',
    taggedContacts: 'Tagged contacts',
    contactTagged: 'Contact tagged:',
    contactsTagged: 'Contacts tagged:',
    startDate: 'Start date',
    endDate: 'End date',
    currently: 'Currently',
    cityOrCountryName: 'City or country name',
    duration: 'Duration',
    currentlyLivingHere: 'I currently live in this place',
  },
  notesScreen: {
    title: 'Notes',
    sharedNote: 'Shared note',
    personalNote: 'Personal note',
    shared: 'shared',
    personal: 'personal',
    allNotes: 'All',
    searchPeople: 'Search a person',
    searchNotes: 'Search in notes',
  },
  scheduledMessagesScreen: {
    private: 'Private',
    pro: 'Pro',
    groups: 'Groups',
    categoriesTab: 'Categories',
    title: 'Scheduled messages',
    results: '{count} results',
    scheduledFor: 'Scheduled for {time}',
    editing: 'Edit the message below',
    deleteConfirm: 'this scheduled message',
    createMessage: 'Create a message',
    loadError: 'Your scheduled messages could not be loaded.',
    chooseRecipient: 'Choose a recipient',
    typeMessage: 'Type a message',
    deleteScheduledMessage: 'Delete scheduled message',
  },
  hashtagsScreen: {
    notFound: 'Hashtag not found',
    newHashtag: 'New hashtag',
    person: '{count} person',
    persons: '{count} people',
    results: '{count} result',
    resultsPlural: '{count} results',
  },
  relationalColorsScreen: {
    title: 'Relational colors',
    notFound: 'Associated color not found',
    person: '{count} person',
    persons: '{count} people',
    results: '{count} result',
    resultsPlural: '{count} results',
  },
  categoriesScreen: {
    title: 'Categories',
    addSubcategory: 'Add a subcategory',
    subcategoryPhoto: 'Subcategory photo',
    subcategoryPlaceholder: 'Subcategory title...',
    categoryPhoto: 'Category photo',
    newCategory: 'New category',
    categoryTitlePlaceholder: 'Category title...',
    addCategory: 'Add a category',
    addSubcategoryWithPhoto: 'Add a subcategory',
    person: '{count} person',
    persons: '{count} people',
    backToList: 'Back to categories list',
    categoryContacts: 'In this category',
  },
  notificationsScreen: {
    toAddPeople: 'to add people',
    acceptAsPro: 'Accept as professional',
    acceptAsPrivate: 'Accept as private',
    accept: 'Accept',
  },
  notifications: {
    friendRequest: 'Friend request',
    acceptedRequest: 'Request accepted',
    rejectedRequest: 'Request declined',
    upcomingEvent: 'Upcoming event',
    contactReminder: 'Keep in touch reminder',
    scheduledMessage: 'Scheduled message',
    birthday: 'Birthday',
    eventReminder: 'Event reminder',
    syncContacts: 'Sync my contacts',
    toAddPeople: 'To add people',
    all: 'All',
    requests: 'Requests',
    agenda: 'Agenda',
    accept: 'Accept',
    reject: 'Decline',
    accepted: 'Accepted',
    rejected: 'Declined',
    acceptAsPro: 'Accept as professional',
    acceptAsPrivate: 'Accept as private',
    orRejectRequest: 'Or decline the request',
    requestGone: 'This request is no longer available.',
    sentRequests: 'Sent requests',
    receivedRequests: 'Received requests',
    sections: {
      today: 'Today',
      tomorrow: 'Tomorrow',
      thisWeek: 'This week',
      earlier: 'Earlier',
    },
    empty: {
      title: "You're all caught up",
      subtitle: 'You have no notifications right now.',
    },
    loadError: {
      title: 'Could not load your notifications',
      subtitle: 'Check your connection, then try again.',
      retry: 'Try again',
      stale: 'This list may be out of date.',
    },
    markAllRead: 'Mark all as read',
    markAllReadShort: 'All read',
    ago: '{time} ago',
    justNow: 'just now',
    titles: {
      keepContact: 'Keep in touch with {name}',
      request: '{name} would like to add you to their contacts',
      birthdayAge: '{name} turns {age} today',
      birthday: "It's {name}'s birthday today",
      scheduledMessage: 'Scheduled message for {name}',
      event: 'Appointment',
      birthdayTomorrowAge: 'Tomorrow, {name} turns {age}',
      birthdayTomorrow: "Tomorrow is {name}'s birthday",
      accepted: '{name} accepted your contact request',
      acceptedByMe: '{name} is now one of your {scope} contacts',
      sent: 'Your scheduled message was sent to {name}',
      sentGroup: 'Your scheduled message was sent to the group {name}',
      done: 'Noted! You caught up with {name}',
    },
    when: {
      today: 'Today',
      tomorrow: 'Tomorrow',
      todayAt: 'Today at {time}',
      tomorrowAt: 'Tomorrow at {time}',
      dayAt: '{day} at {time}',
      late: '{count, plural, one {1 day late} other {{count} days late}}',
    },
    lastMessage: 'last message {ago}',
    actions: {
      write: 'Write',
      postpone: 'Postpone',
      wish: 'Wish them',
      seeEvent: 'See appointment',
      seeProfile: 'See profile',
      seeCard: 'See card',
      edit: 'Edit',
      acceptPrivate: 'Accept as private',
      acceptPro: 'Accept as pro',
      reject: 'Decline',
      done: 'Done',
      undo: 'Undo',
      route: 'Directions',
      warnLate: "Say I'm running late",
      call: 'Call',
      sms: 'Send a text',
      email: 'Send an email',
      scheduleWish: 'Schedule my wishes',
      editWish: 'Edit my wishes',
      seeConversation: 'See the conversation',
    },
    postpone: {
      title: 'Remind me',
      tomorrow: 'Tomorrow',
      in3Days: 'In 3 days',
      inAWeek: 'In 1 week',
      inAMonth: 'In 1 month',
      pickDate: 'Pick a date…',
    },
    later: {
      keepContacts: '{count, plural, one {{count} follow-up} other {{count} follow-ups}}',
      calendarEvents: '{count, plural, one {{count} appointment} other {{count} appointments}}',
      scheduledMessages: '{count, plural, one {{count} scheduled message} other {{count} scheduled messages}}',
      line: 'Planned later: {items}.',
      seeKeepContacts: 'See my follow-ups',
      seeCalendar: 'See my appointments',
    },
    details: {
      eve: "Write your wishes now: they'll be sent tomorrow at {time}.",
      eveScheduled: "Your wishes will be sent tomorrow at {time}.",
      eveGhost: 'Contact card without a KeepTouch account: remember to call tomorrow.',
      ghostPhone: 'Contact card without a KeepTouch account: no message in the app, but their number is saved.',
      ghostNoPhone: 'Contact card without a KeepTouch account.',
      acceptedScope: "You're now connected ({scope}).",
      acceptedNoScope: "You're now connected.",
      mutual: '{count, plural, one {1 contact in common: {names}} other {{count} contacts in common: {names}}}',
      nextReminder: 'Next reminder: {day}',
      finished: 'This follow-up is finished.',
      lateMessage: "Sorry, I'm running a little late, I'll be there as soon as I can.",
      warnWho: 'Tell who?',
    },
    scope: {
      PRIVATE: 'Private',
      PROFESSIONAL: 'Pro',
    },
    toasts: {
      wishScheduled: 'Wishes scheduled for tomorrow at {time}',
      settingsSaved: 'Settings saved',
    },
  },
  notificationSettings: {
    title: 'Notification settings',
    sectionPhone: 'Notify me on my phone',
    sectionQuiet: 'Fewer interruptions',
    keepContact: 'Keep in touch',
    birthdays: 'Birthdays',
    events: 'Appointments',
    messages: 'New messages',
    requests: 'Contact requests',
    morningDigest: 'Morning summary',
    quietHours: 'Do not disturb',
    digestNote: 'One summary in the morning ("1 birthday, 2 people to get back to") instead of several notifications.',
    digestDelayed: 'With "Do not disturb" until {hour}, the summary arrives at {hour}.',
    quietNote: 'At night, reminders wait for the morning.',
    choices: {
      keepContact: {
        onTime: 'At the planned time',
        morning: 'On the day, at 9:00',
        off: 'Never',
      },
      birthdays: {
        eveAndDay: 'The day before and on the day',
        day: 'On the day',
        off: 'Never',
      },
      events: {
        '15': '15 minutes before',
        '30': '30 minutes before',
        '60': '1 hour before',
        '120': '2 hours before',
        off: 'Never',
      },
      live: {
        always: 'Always',
        exceptNight: 'Except at night',
        off: 'Never',
      },
      morningDigest: {
        off: 'No',
        '7': 'Every day at 7:00',
        '8': 'Every day at 8:00',
        '9': 'Every day at 9:00',
      },
      quietHours: {
        off: 'Off',
        '21-7': 'From 21:00 to 7:00',
        '22-7': 'From 22:00 to 7:00',
        '22-8': 'From 22:00 to 8:00',
        '23-7': 'From 23:00 to 7:00',
        '23-8': 'From 23:00 to 8:00',
      },
    },
    open: 'Notification settings',
  },
  mapScreen: {
    title: 'Map',
    contactFound: '{count} contact found in this area',
    contactsFound: '{count} contacts found in this area',
    contactsFoundInZone:
      '{count, plural, =0 {No contact on the map} one {{count} contact on the map} other {{count} contacts on the map}}',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    zoomLevel: 'Zoom level',
    me: 'Me',
    myPosition: 'You are here',
    locateMe: 'Locate me',
    myPositionHidden: 'You are here (hidden from your contacts)',
    hideMe: "Hide me from my contacts' map",
    showMe: "Show me on my contacts' map",
    nowHidden: "You are hidden from your contacts' map",
    nowVisible: "You are visible on your contacts' map",
    nowVisiblePro: "You are visible on your professional contacts' map",
    nowVisiblePrivate: "You are visible on your private contacts' map",
  },
  birthdaysScreen: {
    title: 'Birthdays',
    upcoming: 'Upcoming birthdays',
    private: 'Private',
    pro: 'Pro',
    noBirthday: 'No birthday',
    // Wish pre-filled in the conversation when the AI can't write one.
    wish: {
      opening: 'Happy birthday {firstName}!',
      openingEarly: 'Happy early birthday, {firstName}!',
      openingBelated: 'Happy belated birthday, {firstName}!',
      milestone: '{age}, that calls for a celebration!',
      private: 'Have a great day! 🎂',
      privateBelated: 'I hope you had a great day! 🎂',
      pro: 'Wishing you an excellent day.',
      proBelated: 'I hope you had an excellent day.',
    },
  },
  keepContactScreen: {
    private: 'Private',
    pro: 'Pro',
  },
  qrCodeScreen: {
    shareProfile: 'Share profile',
    copyLink: 'Copy link',
    download: 'Download',
  },
  webFooter: {
    legalNotice: 'Legal notice',
    contactUs: 'Contact us',
    privacyPolicy: 'Privacy policy',
    joinUs: 'Join us',
  },
  legalNotice: {
    editor: 'Publisher',
    editorContent:
      'KeepTouch SAS\nRegistered capital: €10,000\nHead office: Paris, France\nPublication director: KeepTouch Team',
    hosting: 'Hosting',
    hostingContent:
      'The website is served by Netlify. The application servers are hosted by Google Cloud (Cloud Run).',
    intellectualProperty: 'Intellectual property',
    intellectualPropertyContent:
      'All content on the KeepTouch application (texts, images, logos, icons, software) is the exclusive property of KeepTouch SAS and is protected by French and international intellectual property laws. Any reproduction, representation, or distribution without prior written authorization is prohibited.',
    liability: 'Liability',
    liabilityContent:
      'KeepTouch SAS strives to provide accurate and up-to-date information. However, it cannot guarantee the accuracy, completeness, or timeliness of the information available on the application. KeepTouch SAS shall not be held liable for any direct or indirect damages resulting from the use of the application.',
  },
  contactUs: {
    description:
      'Do you have a question, a suggestion, or need assistance? Feel free to reach out to us. Our team will get back to you as soon as possible.',
    emailLabel: 'Email',
    email: 'contact@keeptouch.app',
    addressLabel: 'Address',
    address: 'KeepTouch SAS\nParis, France',
  },
  privacyPolicy: {
    introduction:
      'KeepTouch is committed to protecting the privacy and personal data of its users. This privacy policy describes how we collect, use, and protect your information.',
    dataCollection: 'Data collection',
    dataCollectionContent:
      'We collect data that you voluntarily provide when creating your account and using the application: name, email address, contacts, notes, reminders, and any other information you choose to share.',
    dataUsage: 'Data usage',
    dataUsageContent:
      'Your data is used exclusively to provide and improve the KeepTouch service. We do not sell or share your personal data with third parties for marketing purposes.',
    dataProtection: 'Data protection',
    dataProtectionContent:
      'We implement appropriate technical and organizational security measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction.',
    cookies: 'Cookies',
    cookiesContent:
      'The application may use cookies and similar technologies to improve the user experience and analyze usage. You can manage your cookie preferences at any time from your settings.',
    rights: 'Your rights',
    rightsContent:
      'In accordance with the GDPR, you have the right to access, rectify, delete, and port your personal data. You also have the right to restrict and object to the processing of your data. To exercise these rights, contact us at: contact@keeptouch.app',
    // DRAFT — "Events" section to be reviewed by a lawyer before going to production
    // (see docs/rgpd/points-a-valider-juriste.md in the API).
    eventsTitle: 'Events',
    eventsIntro:
      "This section applies when you register for an event organized with KeepTouch (link, QR code or invitation). KeepTouch is responsible for the attendee list in the app. The organizer receives part of this data to run their event and is responsible for how they use it.",
    eventsData: 'Data concerned',
    eventsDataContent:
      "Depending on how you register: first name, last name, email address, job and company (form); or, with LinkedIn, your name, verified email, photo and the language of your LinkedIn account (the raw information returned by LinkedIn is kept in your KeepTouch profile). If you already have a KeepTouch account, your profile (job, company, photo, LinkedIn link) is used. Also: the date and method of registration, your attendance if the organizer ticks you at the door and, for a paid event, the payment (amount, date, status).",
    eventsPurposes: 'What this data is used for',
    eventsPurposesContent:
      "Registering you and sending your sign-in code and registration confirmation; showing the attendee list to the other registered attendees so everyone can keep in touch; letting an attendee add you directly to their contacts, with the event name as meeting place; letting the organizer run their event (list, check-in, export); writing to you when the event ends (the people you met); processing a ticket payment.",
    eventsLegalBasis: 'Why we are allowed to use it',
    eventsLegalBasisContent:
      "Performing the service you ask for: your registration and connecting you with the other attendees. Registering means you accept to appear in the list, and you can withdraw at any time by unregistering. The legitimate interest of KeepTouch and the organizer in running the event (list, check-in, security). The legal obligation to keep payments for accounting.",
    eventsRecipients: 'Who sees your data',
    eventsRecipientsContent:
      "The other registered attendees, from the moment you register: your first name, last name, job, company, photo and LinkedIn link. Never your email or your notes. Anyone with the event link or QR code: only attendees' first names and photos, as long as the public page is open. The organizer: your name, job, company, email, attendance and, if any, your payment; they can export the list; they never see your notes. An attendee who adds you: your card enters their contacts, with no request or notification. Our technical providers, who act only on our instructions: hosting, email delivery and, once online payment is enabled, a payment provider. KeepTouch does not sell your data.",
    eventsRetention: 'How long we keep it',
    eventsRetentionContent:
      "An event's attendee list, invitations, check-ins and meeting origins are deleted 24 months after the event ends. People who added you to their contacts, and people you added to yours, stay in those contacts: each contact belongs to the person who created it. If you delete your account, you disappear from other people's contacts. Payments are kept for 10 years (accounting obligation); if you delete your account, they remain with no link to you. If you delete your account, your events data is erased immediately, except payments. Sign-in codes sent by email are erased at the latest two days after they expire.",
    eventsInvitations: 'Invitations received by email',
    eventsInvitationsContent:
      "When an organizer enters your address to invite you, KeepTouch sends you an invitation that says who is inviting you and to which event. The \"Stop receiving KeepTouch invitations\" link in that email puts your address on an opt-out list: you will not receive any more invitations from us.",
    eventsLinkedIn: 'Signing in with LinkedIn',
    eventsLinkedInContent:
      "We only receive what LinkedIn provides for sign-in: name, verified email, photo, language and LinkedIn identifier. We post nothing on LinkedIn and have no access to your contacts or network. You can remove KeepTouch's access from your LinkedIn account settings.",
    eventsRights: 'Your rights and how to use them',
    eventsRightsContent:
      "Access, rectification, erasure, objection, restriction and portability. You can: unregister from an event on the event page; edit your profile in the app; delete your account from Settings > Delete my account (if your account has no password yet, create one first in Settings); refuse invitations with the link in every invitation; download a free copy of your events data (registrations, attendance, payments, invitations received, contacts added from an event, organizer requests) as JSON or a spreadsheet (CSV), from Settings > Export my events data. For any other request, write to us: we reply within one month. You can also contact your data protection authority (in France, the CNIL: cnil.fr).",
  },
  joinUs: {
    description:
      'KeepTouch is an innovative application dedicated to helping people maintain and strengthen their relationships. Join our team and contribute to a project that makes a difference!',
    whyJoin: 'Why join KeepTouch?',
    whyJoinContent:
      '• Work on an innovative project with social impact\n• Join a passionate and dynamic team\n• Flexible and remote-friendly work environment\n• Growth and development opportunities',
    positions: 'Open positions',
    positionsContent:
      'We are always looking for talented people to join our team. Current openings include:\n\n• Full-Stack Developer (React Native / NestJS)\n• UX/UI Designer\n• Marketing & Growth Manager\n• Community Manager',
    apply: 'How to apply',
    applyEmail: 'jobs@keeptouch.app',
  },
  emotionalContexts: {
    'affection-intimite': {
      name: 'Affection & Intimacy',
      description: 'These contacts nurture your heart.',
    },
    'aspiration-inspiration': {
      name: 'Aspiration & Inspiration',
      description: 'These contacts lift you up.',
    },
    'stimulation-aventure': {
      name: 'Stimulation & Adventure',
      description: 'These contacts bring movement and excitement to your life.',
    },
    'soutien-stabilite': {
      name: 'Support & Stability',
      description: 'These contacts support you emotionally and give you structure.',
    },
    'reflexion-profondeur': {
      name: 'Reflection & Depth',
      description: 'These contacts help you think, understand yourself, and grow.',
    },
    'lacher-prise-detente': {
      name: 'Letting go & Relaxation',
      description: 'These contacts help you breathe, disconnect, and exist without pressure.',
    },
    affection: 'Affection',
    'joie-chaleureuse': 'Warm joy',
    'tendre-complicite': 'Tender complicity',
    'presence-reconfortante': 'Comforting presence',
    'partage-authentique': 'Authentic sharing',
    aspiration: 'Aspiration',
    motivation: 'Motivation',
    source: 'Source',
    'elan-creatif': 'Creative impulse',
    'grandeur-ame': 'Greatness of soul',
    stimulation: 'Stimulation',
    aventure: 'Adventure',
    exploration: 'Exploration',
    'adrenaline-partagee': 'Shared adrenaline',
    fun: 'Fun',
    soutien: 'Support',
    encouragement: 'Encouragement',
    securite: 'Security',
    apaisement: 'Soothing',
    'croissance-lente': 'Slow growth',
    apprentissage: 'Learning',
    comprehension: 'Understanding',
    miroir: 'Mirror',
    'conscience-soi': 'Self-awareness',
    'conversations-vraies': 'True conversations',
    detente: 'Relaxation',
    legerete: 'Lightness',
    'presence-sans-enjeu': 'Presence without stakes',
    rire: 'Laughter',
    instantaneite: 'Spontaneity',
  },
  meetingContexts: {
    'ecole-universite': 'School / University',
    travail: 'Work',
    'evenement-pro': 'Professional event',
    'evenement-social': 'Social event',
    'amis-connaissance': 'Friends / Acquaintance',
    voyage: 'Travel',
    'sport-activite': 'Sport / Activity',
    'en-ligne': 'Online',
    dating: 'Dating',
    famille: 'Family',
  },
  rrule: {
    custom: 'Custom',
  },
  relationshipStatus: {
    growing: 'Growing',
    stable: 'Stable',
    to_reconnect: 'To reconnect',
    fluctuating: 'Fluctuating',
    declining: 'Declining',
    ended: 'Ended',
  },
  nearby: {
    headerTitle: 'Nearby',
    pageTitle: 'Nearby contacts',
    perimeter10: 'Profiles within 10 km',
    perimeter50: 'Profiles within 50 km',
    perimeter100: 'Profiles within 100 km',
    perimeter10Short: 'Within 10 km',
    perimeter50Short: 'Within 50 km',
    perimeter100Short: 'Within 100 km',
    perimeterLabel: 'Perimeters',
    visibilityAll: 'You are currently visible to all users.',
    visibilityProfessional: 'You are currently visible to your professional contacts.',
    visibilityPrivate: 'You are currently visible to your private contacts.',
    visibilityHidden: 'You are currently not visible to anyone nearby.',
    visibilityAllMobile: 'Visible to all users.',
    visibilityProfessionalMobile: 'Visible to your professional contacts.',
    visibilityPrivateMobile: 'Visible to your private contacts.',
    visibilityHiddenMobile: 'Visible to no one.',
    visibilityLoading: 'Loading your visibility...',
    editVisibility: 'Edit my visibility',
    filterPrivate: 'Private',
    filterPro: 'Pro',
    emptyNoResults: 'No results.',
    emptyNoContacts: 'No nearby contacts found.',
    groupLabel: 'Profiles within {distance} km!',
    visibilityOptionAllTitle: 'Pro & Private',
    visibilityOptionAllDescription:
      'Your profile is visible to all users (professional and private).',
    visibilityOptionProTitle: 'Pro',
    visibilityOptionProDescription: 'Visible only to professionals and companies.',
    visibilityOptionPrivateTitle: 'Private',
    visibilityOptionPrivateDescription: 'Visible only to private users.',
    visibilityOptionHiddenTitle: 'Stay invisible',
    visibilityOptionHiddenDescription: 'Your profile is not shown to anyone nearby.',
    modalTitle: 'Edit my visibility',
    modalSubtitle: 'Choose who can see your profile on KeepTouch',
    modalHint: 'Check one or more options according to your needs.',
    updateButton: 'Update visibility',
    scopePrivate: 'Private',
    scopePro: 'Pro',
    noPosition:
      'Your position is not known yet. Allow location on this device to see your nearby contacts.',
    noPositionHidden:
      'You are invisible: your position is not saved, so the list cannot be worked out.',
    loadError: 'An error occurred. Try again.',
    visibilityUnknown: 'Your visibility could not be loaded.',
  },
  ai: {
    assistant: 'AI Assistant',
    tabSuggest: 'Suggest',
    tabSummarize: 'Summarize',
    tabAnalyze: 'Analyze',
    generateSuggestions: 'Generate suggestions',
    use: 'Use',
    summaryInProgress: 'Summarizing...',
    analysisInProgress: 'Analyzing...',
    sentiment: 'Sentiment',
    sentimentUndetermined: 'Undetermined',
    topics: 'Topics covered',
    dynamics: 'Dynamics',
    keyPoints: 'Key points',
    errorRetry: 'An error occurred. Try again.',
    instructionsPlaceholder: "Instructions (optional): e.g. 'formal tone', 'suggest a meeting'...",
    generatedByAi: 'Message generated by AI',
  },
  scheduledMessage: {
    create: {
      reasonQuestion: 'What is the reason for the message?',
      writeManually: 'Write it myself',
      recipientBadge: 'To',
      reasonBadge: 'Reason',
      additionalDetailsPlaceholder: 'E.g. He just landed a new job...',
      messageForContact: 'Message for {name}',
      additionalDetails: 'Additional details (optional)',
      scheduledFor: '{date} at {time}',
      reasons: {
        birthday: 'Birthday',
        reconnect: 'Get back in touch',
        congratulations: 'Congratulations',
        thank_you: 'Thank you',
        check_in: 'Check in',
        new_year: 'New Year / Holidays',
        encouragement: 'Encouragement',
        other: 'Other',
      },
      generateWithAi: 'Generate with AI',
      generating: 'Generating...',
      regenerate: 'Regenerate',
      regenerating: 'Regenerating...',
      writeYourMessage: 'Write your message',
      reviewAndSend: 'Review and send',
      generateFailedTitle: 'The AI could not write the message',
      generateFailedMessage: 'Try again, or write it yourself.',
    },
    schedule: {
      programButton: 'Schedule',
    },
  },
  cardScan: {
    awaitingCamera: 'Waiting for camera...',
    allowCamera: 'Allow camera',
    retake: 'Retake',
    analyze: 'Analyze',
    dragDropPhoto: 'Drag and drop a photo of a business card here',
    orClickToSelect: 'or click to select a file',
  },
  qrCodeScan: {
    title: 'Scan a QR Code',
    headerTitle: 'QR Code',
  },
  ghostForm: {
    tagsSection: 'Tags',
    pinsSection: 'Pins',
    organizeProfile: 'Organize the profile',
    hashtagPlaceholder: 'Name of the #...',
    goalPlaceholder: 'Build a house...',
    profileHashtagsName: 'Profile hashtag',
    facebook: 'Facebook',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
    twitter: 'Twitter',
  },
  notes: {
    empty: {
      titleShared: 'No "shared" note',
      titlePersonal: 'No "personal" note',
      pressPlusToCreate: 'Tap + to create your first note',
      noMatch: 'No note matches this search',
    },
    loadError: {
      title: 'Notes could not be loaded',
      subtitle: 'Check your connection, then try again.',
      partial: 'Not all notes could be loaded.',
    },
    sections: {
      pinned: 'Pinned',
      today: 'Today',
      thisWeek: 'This week',
    },
    dates: {
      today: 'Today',
      yesterday: 'Yesterday',
    },
    sharedBy: 'Shared by {name}',
    readOnly: 'Only its author can edit it.',
    summaryTitle: 'What I know about {name}',
    summaryFootnote: 'Summary by the AI Assistant from your notes',
    toRemember: 'To remember:',
    historyTitle: 'History with {name}',
    history: {
      note: 'Note',
      message: 'Message',
      event: 'Meeting',
      keepContact: 'Reminder',
      line: '{type} · ',
    },
    source: {
      assistant: 'AI Assistant',
      voice: 'Dictated',
    },
    dictateNote: 'Dictate a note',
    stopRecording: 'Stop · {time}',
  },
  editCategory: {
    title: 'Edit a category',
    deleteConfirm: 'this category',
  },
  editHashtag: {
    deleteConfirm: 'this hashtag',
  },
  editNote: {
    deleteConfirm: 'this note',
    saved: 'Saved',
    saving: 'Saving…',
    close: 'Close',
    notSaved: 'Not saved',
    notSavedTitle: 'Note not saved',
    notSavedMessage: 'This note could not be saved. Check your connection, then try again.',
    retry: 'Try again',
    leaveWithoutSaving: 'Leave without saving',
    keepEditing: 'Stay on the note',
  },
  ghostProfileExtra: {
    amisEnCommun: 'Mutual friends',
    inContactWith: 'In contact with {names}',
  },
  formExtra: {
    selectTime: 'Select a time',
    yourMessage: 'Your message...',
    chooseTime: 'Choose the time',
    cancel: 'Cancel',
  },
  filterHeader: {
    clear: 'Clear',
  },
  messagesPinned: {
    label: 'Pinned',
  },
  translate: {
    toggle: 'Translate',
    original: 'Original text',
    lang: {
      fr: 'French',
      en: 'English',
      es: 'Spanish',
    },
  },
  mergeSuggestions: {
    ghostBadge: 'Ghost',
    realBadge: 'Real contact',
    reason: {
      FullName: 'Same full name',
      LastName: 'Same last name',
      FirstName: 'Same first name',
      Email: 'Same email',
      Phone: 'Same phone',
      LinkedIn: 'Same LinkedIn',
      Instagram: 'Same Instagram',
      Facebook: 'Same Facebook',
      Twitter: 'Same Twitter',
    },
    confirmTitle: 'Merge these two profiles?',
    confirmKept: '“{ghost}” (a card you created) will be merged into the contact {real}. Its notes, reminders, scheduled messages, categories, hashtags and colours move to {real}. What you typed on the card (phone, email, birthday, profession, appointments…) is kept in a private note. The photo and the card itself are deleted. This cannot be undone.',
    confirmLost: '“{ghost}” (a card you created) will be merged into the contact {real}. Its notes, reminders, scheduled messages, categories, hashtags and colours move to {real}. What you typed on the card (phone, email, birthday, photo…) will be erased. This cannot be undone.',
    confirmGhostPair: '“{ghost}” will be merged into your other card “{kept}”. Its notes, reminders, appointments, categories, hashtags and colours move to the card that is kept. Missing details are added to it; those that differ are kept in a private note. The duplicate card is deleted. This cannot be undone.',
    done: 'Profiles merged',
    doneNote: 'What was on the card is in a note on {name}.',
    doneGhostNote: 'The details that differ are in a note on {name}.',
    failed: 'The merge could not be done. Nothing was changed.',
  },
  ftSocialImport: {
    title: 'Import from a social network',
    chooseNetwork: 'Choose a social network',
    usernameLabel: 'Username',
    linkedinNameLabel: "Person's name",
    startImport: 'Start the import',
    placeholder: {
      linkedin: 'First name Last name (e.g. Jane Doe)',
      facebook: 'URL or username (e.g. https://facebook.com/zuck)',
      twitter: 'URL or username (e.g. https://x.com/elonmusk)',
      instagram: 'Username (e.g. ethpas)',
      generic: 'Username',
    },
    launched: {
      title: 'Import started',
      message: 'The import has started. You can follow its progress from the contacts list.',
      networkMessage: 'The {network} import has started.',
    },
    error: {
      title: 'Error',
      startFailed: 'Could not start the import',
      validateFailed: 'Could not validate the selection',
      genericError: 'An error occurred',
    },
    previousImports: 'Previous imports',
    newImport: 'New import',
    inProgress: 'Import in progress…',
    failed: 'Failed',
    alreadyAdded: 'Already added',
    profilesFound: '{count, plural, one {# profile found} other {# profiles found}}',
    networkDescription: {
      linkedin: 'Enter the name of the person to search for',
      generic: 'Enter the {network} username to import their followers',
    },
    results: {
      title: 'Results — {network}',
      runningHint: 'This may take a few minutes',
      failedTitle: 'The import failed',
      selectAll: 'Select all',
      deselectAll: 'Deselect all',
      validate: 'Validate selection ({count})',
      successTitle: 'Success',
      successMessage: '{count, plural, one {# profile imported} other {# profiles imported}}',
      loadMore: 'Show more',
      shownOf: '{shown} shown out of {total}',
      empty: 'No profile to show for this import.',
      partial: '{count, plural, one {# profile was added} other {# profiles were added}} before this error.',
    },
  },
  notFoundPage: {
    title: 'Page not found',
    message: 'This address does not exist or no longer exists.',
    button: 'Back to my contacts',
    buttonLoggedOut: 'Back to the home page',
  },
  // --- Events POC ---
  createPassword: {
    title: "Create your password",
    subtitle: "To sign back in later with your email, without waiting for a code.",
    password: "Password",
    confirm: "Confirm password",
    rule: "At least {min} characters",
    mismatch: "The two passwords don't match.",
    save: "Save",
    later: "Later",
    savedTitle: "Password created",
    savedMessage: "You can now sign in with your email and this password.",
    settingsTitle: "Password",
    settingsDescription: "This account has no password yet: it signs in with a code sent by email.",
    settingsButton: "Create my password",
  },
  loginWithCode: {
    title: "Sign in with a code",
    subtitle: "Get a 6-digit code by email: no password needed.",
    link: "Sign in with a code sent by email",
    withPassword: "Sign in with a password",
  },
  admin: {
    title: "Administration",
    forbidden: "This space is reserved for KeepTouch administrators.",
    denied: "This area is reserved for KeepTouch administrators.",
    home: {
      requests: "Organizer requests",
      requestsHint: "Approve or refuse accounts that want to organize events.",
      organizers: "Organizers",
      organizersHint: "Set the ticketing commission of each organizer.",
    },
    requests: {
      title: "Pending requests",
      empty: "No pending requests",
      emptyHint: "New organizer requests will show up here.",
      organization: "Organization",
      message: "Message",
      sentOn: "Request sent on {date}",
      approve: "Approve",
      reject: "Refuse",
      rejectTitle: "Refuse the request",
      rejectDescription: "{name} will receive an email with your reason.",
      rejectReasonLabel: "Reason for refusal (required)",
      toast: {
        approved: "Organizer approved",
        rejected: "Request refused",
      },
    },
    organizers: {
      title: "Organizers",
      searchPlaceholder: "Search by name or email",
      empty: "No organizer found",
      eventCount: "{count, plural, =0 {No events} one {# event} other {# events}}",
      validatedOn: "approved on {date}",
      add: "Add an organizer",
      active: "Active",
      removed: "Removed",
      emptyRemoved: "No removed organizer",
    },
    organizer: {
      title: "Organizer",
      commissionTitle: "Ticketing commission",
      commissionLabel: "Commission rate (%, from 0 to 30)",
      commissionInvalid: "Enter a number between 0 and 30 (example: 7.5).",
      noCommission: "No commission",
      commissionSummary: "{rate}% commission",
      feePaidBy: "Fees paid by",
      feeAttendee: "The attendee",
      feeOrganizer: "The organizer",
      appliesToFuture: "Applies to future payments only.",
      save: "Save",
      billingUnavailable: "Commission settings are not available right now.",
      roleTitle: "Organizer role",
      roleHint: "Removing the role prevents creating or managing events. Existing events are kept.",
      removeRole: "Remove organizer role",
      removeConfirm: "This person will no longer be able to create or manage events. Continue?",
      organizationTitle: "Organization",
      organizationLabel: "Organization name",
      organizationInvalid: "Enter a name (2 characters minimum).",
      saveName: "Save the name",
      statsTitle: "Figures",
      statEvents: "Events",
      statAttendees: "Sign-ups",
      statPaid: "Total paid",
      statCommission: "Commission generated",
      eventsTitle: "Their events",
      noEvents: "No events yet.",
      removedTitle: "Organizer role removed",
      removedHint: "This person can no longer create or manage events. Their existing events are kept.",
      reactivate: "Reactivate the organizer",
      toast: {
        saved: "Commission saved",
        renamed: "Name saved",
        reactivated: "Organizer reactivated",
        removed: "Organizer role removed",
      },
    },
    nav: {
      overview: "Overview",
      requests: "Requests",
      organizers: "Organizers",
      events: "Events",
      settings: "Settings",
    },
    overview: {
      error: "Could not load the figures right now.",
      people: "People",
      organizers: "Active organizers",
      requests: "Pending requests",
      requestsHint: "To approve or refuse",
      attendees: "Confirmed sign-ups",
      attendeesHint: "Confirmed seats, free or paid",
      checkedIn: "Checked in",
      checkedInHint: "Ticked off at the entrance",
      eventsTitle: "Events",
      upcoming: "Upcoming",
      ongoing: "Ongoing",
      past: "Past",
      ticketingTitle: "Ticketing",
      paid: "Total paid",
      paymentsCount: "{count, plural, =0 {No payments} one {# payment} other {# payments}}",
      commission: "KeepTouch commission",
      net: "Net paid out to organizers",
      netHint: "After commission",
      paidOnly: "Only successful payments are counted.",
      nextEvents: "Next events",
      seeAllEvents: "See events",
      noNextEvents: "No upcoming events.",
      latestRequests: "Latest requests",
      seeRequests: "See requests",
      noRequests: "No requests yet.",
      status: {
        pending: "Pending",
        approved: "Approved",
        rejected: "Refused",
      },
    },
    events: {
      title: "Events",
      searchPlaceholder: "Search an event, a code or an organizer",
      phase: {
        upcoming: "Upcoming",
        ongoing: "Ongoing",
        ended: "Ended",
      },
      noOrganizer: "Unknown organizer",
      attendees: "Sign-ups",
      checkedIn: "Present",
      price: "Price",
      free: "Free",
      paidTotal: "Total paid",
      empty: "No event matches.",
      range: "{from}–{to} of {total}",
      previous: "Previous",
      next: "Next",
      pageOf: "Page {page} of {pages}",
      period: "Period",
      periodFrom: "From",
      periodTo: "To",
      periodInvalid: "The start date must be before the end date.",
      preset: {
        today: "Today",
        week: "This week",
        month: "This month",
        last30: "Last 30 days",
      },
      statusLabel: "Status",
      status: {
        upcoming: "Upcoming",
        ongoing: "Ongoing",
        ended: "Ended",
      },
      pricingLabel: "Pricing",
      pricing: {
        free: "Free",
        paid: "Paid",
      },
      categoryLabel: "Category",
      formatLabel: "Format",
      organizerFilter: "Organizer",
      anyOrganizer: "All organizers",
      clearOrganizer: "Remove the organizer filter",
      sortLabel: "Sort by",
      sort: {
        date: "Date",
        attendees: "Sign-ups",
        paid: "Amount collected",
      },
      orderLabel: "Order",
      order: {
        asc: "Ascending",
        desc: "Descending",
      },
      total: "{count, plural, =0 {No events} one {# event} other {# events}}",
      clear: "Clear filters",
      error: "Could not load the events (check the period).",
    },
    eventDetail: {
      title: "Event",
      notFound: "This event could not be found.",
      code: "Code",
      publicPage: "Open the public page",
      figures: "Figures",
      capacity: "Seats",
      unlimited: "Unlimited",
      payments: "Payments",
      information: "Information",
      organizer: "Organizer",
      starts: "Starts",
      ends: "Ends",
      registrationCloses: "Registration closes",
      format: "Format",
      formats: {
        in_person: "In person",
        online: "Online",
        hybrid: "In person and online",
      },
      place: "Place",
      onlineUrl: "Joining link",
      contact: "Contact",
      createdOn: "Created on",
    },
    settings: {
      title: "Settings",
      error: "Could not load the settings right now.",
      commissionTitle: "Default commission",
      commissionHint: "Applied to organizers who have no setting of their own. You can still set a different rate on an organizer’s sheet.",
      serverValue: "Server value, never changed.",
      ownSettingWins: "An organizer’s own setting always takes priority.",
      historyTitle: "Change history",
      historyEmpty: "No change recorded yet.",
      changedBy: "Changed by {name} on {date}",
      unknownAdmin: "an administrator",
      toast: {
        saved: "Settings saved",
      },
    },
    add: {
      title: "Add an organizer",
      searchTitle: "An existing account",
      searchHint: "Search by name or email among all KeepTouch accounts.",
      searchPlaceholder: "Name or email",
      noAccount: "No account matches. Invite this person by email below.",
      alreadyOrganizer: "Already an organizer",
      give: "Give the organizer role",
      organizationLabel: "Organization name (optional)",
      rateLabel: "Commission in % (optional)",
      defaultHint: "Without a setting, the platform’s default commission applies. An “organizer account activated” email is sent.",
      inviteTitle: "No account yet?",
      inviteHint: "The person receives an email with a link to sign up. As soon as they have an account, they become an organizer automatically.",
      emailLabel: "Email address",
      emailInvalid: "Enter a valid email address.",
      invite: "Invite by email",
      accountExists: "This address already has a KeepTouch account. You can give it the role directly.",
      pendingTitle: "Pending invitations",
      pendingEmpty: "No pending invitations.",
      pendingRate: "commission {rate} %",
      pendingSince: "invited on {date} by {name}",
      pendingExpiresOn: "Expires on {date}",
      pendingExpired: "Expired",
      cancelInvitation: "Cancel",
      resendInvitation: "Resend",
      toast: {
        given: "Organizer role given",
        invited: "Invitation sent",
        cancelled: "Invitation cancelled",
      },
    },
    request: {
      blockTitle: "Do you organize events?",
      blockHint: "Ask for an organizer account to create your events and invite attendees. Every request is reviewed by the KeepTouch team.",
      cta: "Become an organizer",
      retry: "Submit a new request",
      rejected: "Request refused: {reason}",
      pendingTitle: "Request sent, awaiting validation",
      pendingHint: "Your request for “{name}” is being reviewed. You will get an email as soon as it is processed.",
      formTitle: "Become an organizer",
      formIntro: "Tell us about your activity. We review your request and reply by email.",
      organizationLabel: "Organization or event name",
      organizationError: "Enter your organization name (2 characters minimum).",
      messageLabel: "Tell us about your events",
      messageError: "Briefly describe the events you organize.",
      websiteLabel: "Website (optional)",
      websiteError: "Enter an address starting with http:// or https://.",
      send: "Send my request",
      toast: {
        sentTitle: "Request sent",
        sentMessage: "We will get back to you by email.",
      },
    },
  },
  events: {
    checkin: {
      title: "Check-in",
      startTitle: "Event check-in",
      startHint: "Optional. Tick people in at the door: those who could not come will get a recap of who was there.",
      start: "Start check-in",
      counter: "{present, plural, one {present} other {present}} out of {total} registered",
      present: "Present",
      absent: "Absent",
      empty: "Nobody registered yet.",
      noResult: "No attendee matches.",
      scan: {
        headerTitle: "Scan",
        instruction: "Point at the attendee's QR code (their personal QR, or their ticket QR).",
        manualLabel: "Paste the QR content",
        manualPlaceholder: "https://keeptouch.co/profile/…",
        manualSubmit: "Confirm",
        cameraUnavailable: "Camera unavailable. Paste the QR content below.",
        checkedInTitle: "{name} — present",
        alreadyTitle: "{name} — already checked in at {time}",
        alreadyTitleOtherDevice: "{name} — already checked in at {time} by another device",
        notRegisteredTitle: "Not registered for this event",
        wrongEventTitle: "Ticket for another event",
        invalidTitle: "QR code not recognised",
        register: "Register them",
        registering: "Registering…",
        continueScanning: "Keep scanning",
        registerFull: "Event full: cannot register on the spot.",
        registerClosed: "Registration is closed.",
        registerPaymentRequired: "This is a paid event: the person needs to pay to register.",
        registerInvalid: "This account could not be registered.",
      },
      offline: {
        banner: "{count, plural, one {Offline — # check-in pending} other {Offline — # check-ins pending}}",
        syncing: "{count, plural, one {Syncing… # check-in pending} other {Syncing… # check-ins pending}}",
      },
    },
    menuTitle: "Events",
    listTitle: "Events",
    tabs: {
      attending: "My registrations",
      organizing: "My events",
      discover: "Discover",
    },
    myStats: {
      entry: "My stats",
      title: "My stats",
      subtitle: "Every event you run, combined.",
      events: "Events",
      registered: "Registered",
      present: "Checked in",
      attendanceRate: "Attendance rate",
      contactsExchanged: "Contacts exchanged",
      followupsSent: "Follow-ups sent",
      emailsSent: "Emails sent",
      collected: "Collected",
      commission: "KeepTouch commission",
      net: "Organizer net",
      curveTitle: "Contacts exchanged — last 7 days",
      curveEmpty: "No contacts exchanged in the last 7 days.",
      empty: "Create your first event to see your stats.",
    },
    discover: {
      title: "Upcoming public events",
      searchPlaceholder: "Search an event, a city, a category",
      searchLabel: "Search",
      nearMe: "Near me",
      allEvents: "All",
      radius: "{km} km",
      radiusLabel: "Radius",
      locCoordinates: "Public events within {km} km of you.",
      locCity: "We don’t know your exact position: showing events in your city.",
      locUnknown: "We don’t know your position. Turn on location in “Nearby” to see events near you. Meanwhile, here are all public events.",
      empty: "No upcoming public events.",
      emptyHint: "Come back soon, or create yours and make it public.",
      emptySearch: "No event matches your search.",
      emptyNear: "No public event near you.",
      emptyNearHint: "Try a wider radius, or see all events.",
      error: "Couldn’t load events.",
      retry: "Try again",
      loadMore: "Show more events",
      loading: "Loading…",
      contactsGoing: "{count, plural, one {# contact is going} other {# contacts are going}}",
      distance: "{km} km away",
      registered: "Registered",
      online: "Online",
      resultsCount: "{count, plural, one {# event} other {# events}}",
    },
    createButton: "Create an event",
    emptyAttending: "You are not registered for any event yet.",
    emptyAttendingHint: "Scan an event QR code or open an invitation link.",
    emptyOrganizing: "No events yet.",
    emptyOrganizingHint: "Create your first event to invite your attendees.",
    phase: {
      upcoming: "Upcoming",
      ongoing: "Happening now",
      ended: "Ended",
    },
    attendeesCount: "{count, plural, =0 {No one registered} one {# registered} other {# registered}}",
    attendeesCountWithCapacity: "{count} / {capacity} seats",
    full: "Full",
    registrationClosed: "Registration closed",
    organizedBy: "Organized by {name}",
    price: {
      free: "Free",
      paid: "Paid",
    },
    payment: {
      simulationBanner: "Simulation: no real payment",
      forEvent: "Paying for your seat at",
      pay: "Pay {amount}",
      priceLine: "Seat price",
      feeLine: "KeepTouch service fee",
      totalLine: "Total",
      simulateFailure: "Simulate a failure",
      cancel: "Cancel",
      seatHeld: "Seat held: {time} left",
      reservedHint: "Your seat is held for you while you pay.",
      resume: "Resume payment — {price}",
      failedTitle: "The payment did not go through",
      failedHint: "You were not charged and your seat is not held. You can try again.",
      retry: "Try again",
      expiredTitle: "Reservation expired",
      expiredHint: "The 15 minutes are over and the seat was released. Start again to book a new one.",
      backToEvent: "Back to the event",
      alreadyPaid: "This payment is already done.",
      notFound: "This payment page could not be found.",
      successTitle: "Payment received",
      successMessage: "Your registration is confirmed. See you there!",
    },
    access: {
      title: "Access denied",
      forbidden: "You don’t have access to this event.",
      notFound: "This event could not be found.",
      back: "Back",
    },
    public: {
      filterAll: "Everyone",
      filterPresent: "Were present",
      whoIsComing: "Who is coming?",
      whoCame: "Attendees",
      teaserHint: "Register to see the attendees' name, job and company.",
      nobodyYet: "No registrations yet.",
      moreAttendees: "+ {count} more",
      notFound: "This event could not be found.",
      notFoundHint: "Check the link or the QR code.",
      manage: "Manage the event",
      youOrganize: "You organize this event",
      youAreRegistered: "You are registered",
      registeredHint: "You can see the other attendees' profiles and add them to your contacts right now.",
      ticketTitle: "Your ticket",
      ticketHint: "Show this QR code at the door.",
      viewFullScreen: "View my ticket full screen",
      leave: "Unregister",
      joinOneClick: "Register in one click",
      reserveSeat: "Book my seat — {price}",
      serviceFee: "incl. {fee} service fee",
      leavePaidHint: "You can unregister, but nothing is refunded (test mode).",
      leaveConfirm: "Unregister from this event?",
      leavePaidConfirm: "Nothing is refunded. If you register again for this event, your paid ticket will be reused (no second payment) as long as seats are left.",
      leaveConfirmYes: "Yes, unregister",
      leaveConfirmNo: "Stay registered",
      endedIntro: "The event is over: add the people you met to your network.",
      you: "You",
    },
    myTicket: {
      title: "My ticket",
      presentAtDoor: "Present this QR code at the door",
      brightnessHint: "Turn up your screen brightness to make scanning easier.",
      unavailableTitle: "Ticket unavailable",
      unavailableHint: "You need to be online to open your ticket for the first time.",
      eventEnded: "The event is over.",
    },
    privacy: {
      title: "By registering, you agree to appear in the attendee list.",
      before: "From the moment you register, the other attendees see your first name, last name, job, company, photo and LinkedIn link. On the event's public page, anyone with the link sees only your first name and photo (until {date}).",
      after: "Other attendees can add you directly to their contacts, with no request to accept and without you being notified; the event name is recorded as the meeting place. Your email and notes are never visible to other attendees.",
      organizer: "The organizer sees your name, job, email and attendance, and can export the list. They never see your notes.",
      durationOne: "This information is deleted 1 month after the event. You can unregister at any time.",
      durationMany: "This information is deleted {months} months after the event. You can unregister at any time.",
      policy: "Privacy policy",
    },
    join: {
      title: "Join the event",
      subtitle: "Register in seconds and meet the other attendees right away.",
      linkedin: "Continue with LinkedIn",
      noLinkedin: "I don't have LinkedIn",
      haveAccount: "Already on KeepTouch?",
      signIn: "Sign in",
      firstName: "First name",
      lastName: "Last name",
      jobTitle: "Job",
      company: "Company (optional)",
      email: "Email",
      sendCode: "Get my code",
      codeSentTo: "Code sent to {email}",
      codeLabel: "6-digit code",
      confirm: "Join the event",
      resend: "Resend the code",
      changeEmail: "Edit my details",
      back: "Back",
      required: "Required",
      invalidEmail: "Invalid email",
      fakeTitle: "LinkedIn simulation (local mode)",
      fakeHint: "Real LinkedIn sign-in will be plugged in once the LinkedIn Developer app exists.",
      fakeContinue: "Simulate LinkedIn sign-in",
      closed: "Registration is closed.",
      full: "The event is full.",
      fullHeld: "Full: some seats are currently being paid for. Try again in a few minutes.",
      linkedinCallbackError: "LinkedIn sign-in did not complete.",
      linkedinLoading: "Signing in with LinkedIn…",
      paidNotice: "Paid event: {price}. You pay in the next step.",
      confirmPaid: "Continue to payment",
    },
    completeProfile: {
      title: "Complete your profile",
      subtitle: "Add your job title so the other attendees can find you.",
      linkedinUrl: "Your LinkedIn profile link (optional)",
      save: "Save",
      later: "Later",
    },
    relation: {
      add: "Add",
      addedTitle: "Added to your contacts",
      addedMessage: "Find them in the Pro tab of your contacts. Meeting place: {event}",
      remove: "Remove",
      removeTitle: "Remove {name} from your contacts?",
      removeDescription: "They will not be notified.",
      contact: "In your contacts",
      linkedin: "LinkedIn",
      meetingPlaceNote: "Meeting place saved: {event}",
    },
    form: {
      createTitle: "New event",
      editTitle: "Edit the event",
      sections: {
        info: "Information",
        dates: "Date and time",
        place: "Location",
        registration: "Registration",
        visibility: "Visibility",
        ticketing: "Ticketing",
        cover: "Cover image",
        contact: "Contact",
      },
      name: "Event name",
      namePlaceholder: "E.g. Paris Tech Afterwork",
      category: "Category",
      description: "Description",
      descriptionPlaceholder: "Agenda, audience, practical details…",
      descriptionCounter: "{count} / {max}",
      startsAt: "Start",
      endsAt: "End",
      format: "Format",
      location: "Venue name",
      locationPlaceholder: "E.g. Station F",
      address: "Address",
      addressPlaceholder: "E.g. 5 Parvis Alan Turing",
      city: "City",
      cityPlaceholder: "E.g. Paris",
      onlineUrl: "Video call link",
      onlineUrlPlaceholder: "https://meet.google.com/…",
      capacity: "Number of seats",
      capacityHint: "Leave empty for unlimited.",
      visibility: "Visibility",
      visibilityOptions: { private: "Private", public: "Public" },
      visibilityHint: {
        private: "Private: the event is not listed anywhere in KeepTouch. Only people you send the link, the QR code or an invitation to can sign up.",
        public: "Public: the event is visible to every KeepTouch user in “Discover”. Great to attract new attendees. The link and QR code still work.",
      },
      ticketing: "Price type",
      price: "Price (in euros)",
      pricePreview: "Shown as: {price}",
      feeByLower: { attendee: "the attendee", organizer: "the organizer" },
      commissionReadonly: "KeepTouch fee: {rate}% paid by {who}.",
      commissionNone: "No KeepTouch fee on this event.",
      priceHint: "Between {min} and {max}. Guests you add yourself never pay.",
      registrationClosesAt: "Registration deadline",
      registrationClosesAtHint: "Optional: by default 7 days after the event ends.",
      coverUpload: "Choose an image",
      coverDrop: "Drag an image here or click to choose",
      coverDropActive: "Drop the image",
      coverChange: "Change",
      coverRemove: "Remove",
      coverUploading: "Uploading the image…",
      coverUploadHint: "JPEG, PNG or WebP, 8 MB maximum.",
      contactEmail: "Contact email",
      contactEmailPlaceholder: "contact@example.com",
      contactEmailHint: "Shown to attendees so they can reach you.",
      websiteUrl: "Website or agenda",
      websiteUrlPlaceholder: "https://",
      save: "Save",
      create: "Create the event",
      delete: "Delete the event",
      deleteConfirm: "Permanently delete this event and its attendee list?",
      cancel: "Cancel",
      errors: {
        name: "Give the event a name (at least 2 characters).",
        dates: "Enter a valid start and end date.",
        order: "The end must be after the start.",
        capacity: "Enter a whole number between 1 and 100,000.",
        url: "The link must start with https://",
        email: "Enter a valid email address.",
        locationRequired: "Enter the venue name.",
        onlineUrlRequired: "Enter the video call link.",
        deadlinePast: "The registration deadline must be in the future.",
        price: "Enter a price between €0.50 and €10,000 (e.g. 25 or 12.50).",
        coverType: "Unsupported format: use a JPEG, PNG or WebP.",
        coverSize: "Image too large: 8 MB maximum.",
      },
    },
    venue: {
      label: "Location",
      placeholder: "Search for a place or an address",
      searching: "Searching…",
      noResults: "No results",
      unavailable: "Search is unavailable. Enter the address by hand.",
      change: "Change",
      manual: "Enter the address manually",
      backToSearch: "Search for a place",
      directions: "Directions",
    },
    category: {
      networking: "Networking",
      conference: "Conference",
      workshop: "Workshop",
      meetup: "Meetup",
      trade_show: "Trade show",
      seminar: "Seminar",
      other: "Other",
    },
    format: {
      in_person: "In person",
      online: "Online",
      hybrid: "Hybrid",
    },
    details: {
      joinOnline: "Join online",
      website: "Website / agenda",
      contact: "Contact",
    },
    manage: {
      back: "My events",
      edit: "Edit",
      viewPage: "View the public page",
      stats: {
        registered: "Registered",
        present: "Checked in",
        attendanceRate: "Attendance rate",
        invitations: "Invitations",
        accepted: "{count} accepted",
        contactsExchanged: "Contacts exchanged",
        followupsSent: "Follow-ups sent",
        emailsSent: "Emails sent",
        collected: "Collected",
        paidCount: "{count, plural, =0 {No payments} one {# payment} other {# payments}}",
        commission: "KeepTouch commission",
        net: "Organizer net",
        netHint: "What the organizer receives",
        collectedShort: "{amount} collected · {price}",
      },
      share: {
        title: "Share",
        hint: "Anyone with this link or who scans this QR code can register.",
        copy: "Copy the link",
        copied: "Link copied",
        downloadQr: "Download the QR code",
      },
      invite: {
        title: "Invite by email",
        hint: "Paste email addresses (separated by commas, spaces or new lines).",
        placeholder: "alice@example.com, bob@example.com…",
        detected: "{count, plural, =0 {No address detected} one {# address detected} other {# addresses detected}}",
        fromContacts: "Pick from my contacts",
        selectedContacts: "{count, plural, one {# contact selected} other {# contacts selected}}",
        send: "Send the invitations",
        result: "{sent, plural, =0 {No invitation sent} one {# invitation sent} other {# invitations sent}}",
        resultRegistered: "{count} already registered",
        resultOptedOut: "{count, plural, one {# address opted out of KeepTouch invitations: skipped} other {# addresses opted out of KeepTouch invitations: skipped}}",
        resultInvalid: "Skipped addresses: {list}",
        pickTitle: "Invite contacts",
        pickDone: "Done",
        history: "Invitations sent",
        accepted: "Accepted",
        pending: "Pending",
      },
      reminders: {
        title: "Automatic reminders",
        hint: "Email + in-app notification sent to confirmed attendees: the day before around 10am, then 2h before the start.",
        enabled: "On",
        disabled: "Off",
      },
      emailing: {
        title: "Emailing",
        hint: "Write to your attendees before or after the event.",
        recipients: "Recipients",
        recipientsAll: "All attendees ({count})",
        recipientsPresent: "Checked in ({count})",
        recipientsAbsent: "Not checked in ({count})",
        recipientsInvited: "Invited, not registered ({count})",
        subject: "Subject",
        subjectPlaceholder: "Tonight's schedule",
        message: "Message",
        messagePlaceholder: "Your message to attendees…",
        alsoNotification: "Also as an in-app notification",
        notificationOnly: "Notification only (no email) — e.g. room change",
        preview: "Preview",
        previewEmpty: "Fill in the subject and message to see the preview.",
        send: "Send",
        sendNotificationOnly: "Send the notification",
        result: "{count, plural, =0 {No recipient} one {Sent to # person} other {Sent to # people}}",
        resultNotificationOnly: "{count, plural, =0 {No recipient} one {Notification sent to # person} other {Notification sent to # people}}",
        history: "Sends history",
        historyEmpty: "Nothing sent yet.",
        historyNotificationBadge: "Notification",
        historyEmailBadge: "Email",
        historyTicketBadge: "Ticket",
        historyAlsoNotification: "+ notification",
        historyRecipients: "{filter} · {count, plural, =0 {no recipient} one {# recipient} other {# recipients}}",
        filter: {
          all: "All attendees",
          present: "Checked in",
          absent: "Not checked in",
          invited: "Invited, not registered",
          one: "One person",
        },
      },
      tickets: {
        title: "Tickets",
        hint: "Resend the ticket QR (by email) to your confirmed attendees.",
        sendAll: "Send to every attendee ({count})",
        sending: "Sending…",
        result: "{count, plural, =0 {No recipient} one {Ticket sent to # person} other {Tickets sent to # people}}",
      },
      attendees: {
        title: "Attendees",
        filterAll: "All",
        filterPresent: "Checked in",
        filterAbsent: "Not arrived yet",
        export: "Export (CSV)",
        empty: "No one has registered yet.",
        emptySearch: "No attendee matches.",
        checkIn: "Check in",
        checkedIn: "Checked in",
        source: {
          linkedin: "LinkedIn",
          manual: "Form",
          account: "KeepTouch account",
        },
        joinedOn: "Registered on {date}",
        collected: "Total paid: {amount} · KeepTouch commission: {commission} · Organizer net: {net} ({count, plural, =0 {no payments} one {# payment} other {# payments}})",
        paid: "Paid",
        unregistered: "Unregistered (paid)",
        sendTicket: "Resend the ticket",
        ticketSentTitle: "Ticket sent",
        ticketSent: "The ticket was resent by email.",
      },
    },
    toast: {
      joinedTitle: "Registration confirmed",
      joinedMessage: "Your seat is booked.",
      leftTitle: "Unregistered",
      leftMessage: "You no longer attend this event.",
      createdTitle: "Event created",
      createdMessage: "Share the link or the QR code to invite your attendees.",
      updatedTitle: "Event updated",
      updatedMessage: "Your changes are saved.",
      deletedTitle: "Event deleted",
      deletedMessage: "The event and its registrations were deleted.",
      exportedTitle: "Export downloaded",
      profileSavedTitle: "Profile updated",
      profileSavedMessage: "Other attendees will see your job.",
      invitedTitle: "Invitations sent",
    },
    native: {
      pickDateTime: "Pick a date and time",
      pickDate: "Pick a date",
      clearDate: "Clear the date",
      shareQr: "Share the QR code",
      shareMessage: "Register for “{name}”: {url}",
    },
  },
} as const

export type TranslationKeys = keyof typeof enTranslations
